{
  "buttons": {
    "saveSettings": "Speichern"
  },
  "login": {
    "welcomeBack": "Willkommen!",
    "pleaseLogin": "Bitte melden Sie sich an.",
    "terms": "Nutzungsbedingungen.",
    "privacy": "Datenschutzbestimmungen",
    "labels": {
      "username": "Nutzername",
      "password": "Passwort",
      "rememberMe": "Angemeldet bleiben",
      "forgotPassword": "Passwort vergessen"
    },
    "code": {
      "enter": "Code aus der E-Mail eingeben",
      "resend": "Code erneut senden"
    },
    "error": {
      "unexpected": "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "credentials": "Ungültige E-Mail-Adresse oder ungültiges Passwort. Bitte versuchen Sie es erneut.",
      "unknown": "Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "otpFailed": "Die Verifizierung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "otpInvalid": "Ungültiger Verifizierungscode. Bitte versuchen Sie es erneut.",
      "enterCode": "Bitte geben Sie den Verifizierungscode ein."
    }
  },
  "register": {
    "title": "Einladung",
    "welcome": "Willkommen!",
    "setPassword": "Bitte wählen Sie ein Passwort.",
    "label": {
      "passwordConfirm": "Passwort bestätigen"
    },
    "message": {
      "passwordSet": "Ihr Passwort wurde erfolgreich gesetzt. Sie können sich nun anmelden.",
      "confirm": "Bitte bestätigen Sie Ihr Passwort.",
      "seeYouAround": "Wir sehen uns!",
      "genericError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut!",
      "expiredToken": "Dieser Einladungslink ist abgelaufen. Bitte fordern Sie bei der Person, die Sie eingeladen hat, eine neue Einladung an.",
      "invalidToken": "Dieser Einladungslink ist nicht mehr gültig. Bitte fordern Sie bei der Person, die Sie eingeladen hat, eine neue Einladung an.",
      "declined": "Ihre Einladung wurde abgelehnt."
    },
    "button": {
      "login": "Anmelden",
      "register": "Registrieren"
    }
  },
  "resetPassword": {
    "title": "Passwort zurücksetzen",
    "message": {
      "emailSent": "Eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts wurde an {email} gesendet. Bitte überprüfen Sie Ihren Posteingang.",
      "passwordReset": "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können nun zur Anmeldeseite gehen.",
      "invalidToken": "Ihr Token ist nicht gültig. Bitte stellen Sie eine weitere Anfrage zum Zurücksetzen Ihres Passworts.",
      "genericError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut!"
    },
    "button": {
      "login": "Anmelden"
    }
  },
  "clients": {
    "addClient": "Neuen Kunden anlegen",
    "createClient": "Kunden anlegen",
    "cancel": "Abbrechen",
    "deactivated": "Deaktivieren",
    "reactivate": "Reaktivieren",
    "deleteClient": "Endgültig löschen",
    "clientName": "Wie heißt der/die Kunde/in?",
    "projects": "Anzahl Map-Projekte:",
    "users": "Anzahl Nutzer:",
    "access": "Zugang erbitten",
    "searchPlaceholder": "Kunden durchsuchen..."
  },
  "mapOverview": {
    "headerTitle": "Map-Übersicht",
    "createMap": "Neue Map erstellen",
    "live": "Live-Ansicht",
    "draft": "Vorschau",
    "edit": "Map bearbeiten",
    "clone": "Map klonen",
    "cloneTemplate": "Vorlage klonen",
    "delete": "Map löschen",
    "access": "Zugang:",
    "lastEdited": "Zuletzt bearbeitet:",
    "mapLiveQuotaToggleLabel": "Live",
    "searchPlaceholder": "Maps durchsuchen...",
    "cloneToClient": {
      "action": "Zu anderem Kunden klonen",
      "title": "Map zu einem anderen Kunden klonen",
      "description": "Wähle den Kunden, der eine Kopie von „{map}“ erhalten soll.",
      "currentClient": "aktueller Kunde",
      "noClients": "Keine Kunden gefunden.",
      "cancel": "Abbrechen",
      "confirm": "Map klonen",
      "confirmTo": "Zu {client} klonen",
      "done": "„{map}“ wurde bei {client} angelegt.",
      "open": "Im Map Builder öffnen",
      "close": "Schließen",
      "failed": "Die Map konnte nicht geklont werden."
    }
  },
  "overviewSort": {
    "label": "Sortieren nach",
    "nameAsc": "Name (A–Z)",
    "nameDesc": "Name (Z–A)",
    "createdDesc": "Erstellt (neueste zuerst)",
    "createdAsc": "Erstellt (älteste zuerst)",
    "modifiedDesc": "Zuletzt geändert (neueste zuerst)",
    "modifiedAsc": "Zuletzt geändert (älteste zuerst)",
    "idAsc": "ID (aufsteigend)",
    "idDesc": "ID (absteigend)"
  },
  "overviewList": {
    "loadMore": "Mehr anzeigen",
    "loading": "Weitere werden geladen…",
    "end": "Alle {count} geladen",
    "empty": "Nichts entspricht Ihrem Filter"
  },
  "mapAccess": {
    "created": "begrenzt",
    "draft": "begrenzt",
    "metered": "teilweise begrenzt",
    "published": "frei zugänglich"
  },
  "header": {
    "button": {
      "buyLicense": "Lizenz kaufen"
    },
    "link": {
      "preview": "Vorschau der Änderungen",
      "live": "Live-Version"
    }
  },
  "dashboardOptions": {
    "createMap": "Map erstellen",
    "drawShapes": "Formen erstellen",
    "drawText": "Text auf der Map",
    "drawEdges": "Verbindung zeichnen",
    "globalDesign": "Globales Design festlegen",
    "objectTemplates": "Objektvorlagen bearbeiten",
    "mapSettings": "Map-Einstellungen",
    "mapLanguages": "Sprache und Übersetzungen",
    "organizeContent": "Inhalte bearbeiten",
    "contentForm": "Inhalte-Formular",
    "editorsNote": "Editorial",
    "glossary": "Glossar",
    "references": "Quellenverzeichnis",
    "headerBar": "Header",
    "tableOfContent": "Inhaltsverzeichnis",
    "mediaAssets": "Medien verwalten",
    "mediaTemplates": "Medienvorlagen",
    "webSettings": "Webeinstellungen verwalten",
    "socialNetworks": "Social Networks hinzufügen",
    "cookieConsent": "Cookie-Einverständniserklärung hinzufügen",
    "seo": "SEO-Einstellungen hinzufügen",
    "mapUrl": "Map-URL bearbeiten",
    "mapAccess": "Map-Zugriff verwalten",
    "mapEmbed": "Map-Einbettungscode",
    "nodeDesign": "Design Knotenpunkte",
    "nodeContent": "Inhalte bearbeiten",
    "nodeVisibility": "Sichtbarkeit des Elements",
    "edgeDesign": "Liniendesign",
    "edgeVisibility": "Sichtbarkeit der Linie",
    "quizTool": "Quiz-Tool"
  },
  "layerOptions": {
    "settings": "Ebeneneinstellungen",
    "level": "Z-Level",
    "edges": "Alle Verbindungslinien",
    "layer": "Ebene",
    "node": "Element"
  },
  "options": {
    "style": {
      "dotted": "Gepunktet",
      "solid": "Durchgezogen",
      "dashed": "Gestrichelt"
    },
    "textPosition": {
      "topLeft": "Oben links",
      "top": "Oben",
      "topRight": "Oben rechts",
      "left": "Links",
      "center": "Mitte",
      "right": "Rechts",
      "bottomLeft": "Unten links",
      "bottom": "Unten",
      "bottomRight": "Unten rechts"
    },
    "contentBar": {
      "detachedSmall": "Freistehend (klein)",
      "detachedMedium": "Freistehend (mittel)",
      "detachedLarge": "Freistehend (groß)",
      "panelSmall": "Seitliche Leiste (klein)",
      "panelLarge": "Seitliche Leiste (groß)"
    },
    "repeat": {
      "noRepeat": "Nicht wiederholen",
      "repeat": "Wiederholen",
      "repeatX": "X wiederholen",
      "repeatY": "Y wiederholen"
    },
    "size": {
      "fill": "Füllen",
      "cover": "Abdecken",
      "contain": "Einpassen",
      "none": "Nichts"
    }
  },
  "field": {
    "w": "B",
    "h": "H",
    "px": "px",
    "color": "Farbe",
    "appearance": {
      "color": "Füllfarbe",
      "crop": "Mediendatei mit Form beschneiden",
      "border": "Rand",
      "shadow": "Schatten",
      "media": "Medien",
      "mediaUrl": "Medien-URL",
      "mediaSize": "Mediengröße",
      "opacity": "Deckkraft",
      "style": "Stil"
    },
    "typography": {
      "textPosition": "Textposition",
      "paragraphSpacing": "Absatzabstand. em ist relativ zur Schriftgröße des Absatzes"
    }
  },
  "objectTemplate": {
    "placeholder": "Vorlage wählen",
    "label": "Aktualisieren oder als neue Objektvorlage speichern",
    "create": "Neue Vorlage erstellen",
    "createShort": "Vorlage erstellen",
    "update": "Vorlage aktualisieren",
    "createdName": "Name für die neue Vorlage",
    "size": "Größe:",
    "font": "Font:",
    "title": "Titel",
    "nodeTemplates": "Punkt Objektvorlagen",
    "edgeTemplates": "Verbindungslinien Objektvorlagen",
    "backButton": "Zurück zur Übersicht"
  },
  "sidebar": {
    "title": {
      "nodeDesign": "Form bearbeiten",
      "textDesign": "Text auf Zeichenfläche bearbeiten",
      "nodeVisibility": "Sichtbarkeit bearbeiten",
      "edgeDesign": "Liniendesign bearbeiten",
      "edgeVisibility": "Sichtbarkeit Verbindungslinien bearbeiten",
      "globalDesign": "Globale Designeinstellungen",
      "objectTemplates": "Objektvorlagen",
      "mapSettings": "Map-Basisdaten"
    },
    "nodeDesign": {
      "clone": "Element klonen",
      "delete": "Element löschen",
      "placeholder": {
        "point": "Neues Element"
      },
      "label": {
        "name": "Name des Punktes",
        "shape": "Form",
        "transformation": "Transformation",
        "appearance": "Aussehen"
      },
      "title": {
        "appearance": "Punktdesign",
        "typography": "Typographie",
        "objectTemplate": "Objektvorlage"
      }
    },
    "visibility": {
      "title": {
        "layers": "Sichtbarkeit auf allen Ebenen",
        "devices": "Sichtbarkeit auf verschiedenen Endgeräten"
      },
      "label": {
        "first": "Erste Ebene",
        "last": "Letzte Ebene",
        "mobile": "Mobil",
        "tablet": "Tablet",
        "desktop": "Desktop"
      }
    },
    "edgeDesign": {
      "title": {
        "appearance": "Aussehen Verbindungen",
        "lettering": "Beschriftung"
      },
      "label": {
        "line": "Verbindungslinienart",
        "lineStart": "Linienanfang festlegen",
        "lineEnd": "Linienende festlegen",
        "start": "Beschriftung Anfang",
        "center": "Beschriftung Mitte",
        "end": "Beschriftung Ende"
      },
      "placeholder": {
        "text": "Beschriftung hinzufügen"
      }
    },
    "globalDesign": {
      "title": {
        "content": "Typographie Inhalte",
        "sections": "Zusätzliche Inhalte",
        "tooltip": "Tooltip-Inhalt",
        "table": "Inhaltsverzeichnis"
      },
      "label": {
        "content": {
          "narrow": "Schmale seitliche Leiste",
          "wide": "Breite seitliche Leiste",
          "detachedLarge": "Freistehende Inhaltebox, groß",
          "detachedSmall": "Freistehende Inhaltebox, klein",
          "detachedMedium": "Freistehende Inhaltebox, mittel"
        },
        "sections": {
          "info": "Weitere Informationen",
          "nav": "Navigation"
        }
      }
    },
    "mapSettings": {
      "title": {
        "canvas": "Zeichenfläche",
        "bg": "Hintergrund",
        "behavior": "Verhalten der Knotenpunkte in Live-Ansicht",
        "palette": "Farbmodus für Bedienelemente",
        "download": "Download Optionen",
        "assistant": "KAIA-Assistent"
      },
      "label": {
        "dimension": "Maße",
        "expansion": "Richtung der Erweiterung",
        "zoom": "Zoom-Ebenen",
        "bgFixed": "Fixiertes Hintergrundbild",
        "position": "Position",
        "repeat": "Wiederholen",
        "size": "Größe",
        "transparency": "Transparenz",
        "highlight": "Markiere gelesene Punkte",
        "tableOfContents": "Zeige ein Inhaltsverzeichnis",
        "searchEngine": "Zeige die Suchfunktion",
        "darkMode": "Dunkler Modus (empfohlen für helle Hintergründe)",
        "brightMode": "Heller Modus (empfohlen für dunkle Hintergründe)",
        "nodesHighlights": "Direkte Verbindungen hervorheben",
        "nodesList": "Direkte Verbindungen unter Inhalt anzeigen",
        "highlightBackdrop": "Hintergrundfarbe beim Hervorheben von Punkten",
        "modificationDate": "Zeige das letzte Änderungsdatum unter dem Inhalt",
        "assistant": "KAIA für diese Map einschalten"
      },
      "button": {
        "exportContent": "Artikelinhalte",
        "exportNodesContent": "Inhalt der Knotenpunkte",
        "exportGlossary": "Glossarbegriffe",
        "exportSnapshot": "Snapshot der Map (letzte Ebene)",
        "exportMedia": "Mediendateien"
      },
      "message": {
        "media": "Alle Mediendateien werden runter geladen. Abhängig von Größe und Menge der Medieninhalte, kann dieser Prozess etwas dauern."
      },
      "tooltip": {
        "downloadInProgress": "Bitte warten Sie bis die Daten zum Herunterladen vorbereitet wurden"
      },
      "hint": {
        "assistant": "Ist KAIA aus, wird der Assistent beim Bearbeiten dieser Map nicht angeboten. In deinen anderen Maps bleibt er verfügbar."
      }
    }
  },
  "common": {
    "soon": "Bald verfügbar",
    "duplicated": "Bereits angemeldet!",
    "language": "Sprache"
  },
  "tooltip": {
    "editMap": "Map-Einstellungen bearbeiten",
    "preview": "Vorschau der aktuellen Änderungen",
    "version": "Versionsverwaltung",
    "mapOverview": "Map-Übersicht",
    "generalSettings": "Basiseinstellungen verwalten",
    "knowledge": "Anleitung",
    "userSettings": "Nutzereinstellungen",
    "clients": "Kunden",
    "logout": "Abmelden",
    "noPermission": "Sie haben keinen Zugriff",
    "noAccess": "Nicht in Ihrem Abonnement verfügbar",
    "readPermission": "Frage den Admin um \n Bearbeitungsrechte zu erhalten.",
    "adminPermission": "Für den Zugriff benötigen Sie Administratorrechte",
    "confirmTranslation": "Um die Übersetzung zu bestätigen, aktivieren Sie das Kontrollkästchen neben jeder Sprache.",
    "languageBoardActive": "Wechsle mit diesem Button zwischen den Sprachen, um schnell alle Übersetzungen zu verwalten. Erweiterte und umfassende Einstellungen findest du im Inhalte-Formular.",
    "languageBoardInactive": "Dies ist die ID der gewählten Standardsprache. Derzeit ist keine zusätzliche Sprache hinzugefügt. Verwalte die Spracheinstellungen in den Map-spezifischen Einstellungen.",
    "gifControlAnimation": "GIF-Steuerungsanimation",
    "visitors": "Wer diese Map gerade bearbeitet",
    "inviteMembers": "Teammitglieder einladen",
    "mapProtocol": "Map-Protokoll",
    "releaseNotes": "Was ist neu"
  },
  "message": {
    "success": "Inhalt erfolgreich gespeichert!",
    "mediaSuccess": "Inhalt der {id}-Datei erfolgreich gespeichert!",
    "nodeCloneSuccess": "Klon des Knotenpunktes {id} wurde erstellt",
    "nodeCloneError": "Fehler beim Klonen des Knotenpunktes",
    "nodeCreatedSuccess": "Knotenpunkt {id} erstellt",
    "nodeCreatedError": "Fehler beim Erstellen eine Knotenpunktes",
    "nodeRemovedSuccess": "Knotenpunkt {id} wurde gelöscht",
    "nodeRemovedError": "Fehler beim Löschen eines Knotenpunktes",
    "nodeDesignSuccess": "Design des Knotenpunktes {id} geändert",
    "nodeDesignError": "Fehler beim Ändern des Designs des Knotenpunktes {id}",
    "nodeContentSuccess": "Inhalt des Knotenpunktes {id} geändert",
    "nodeContentError": "Fehler beim Ändern des Inhalts des Knotenpunktes {id}",
    "nodeVisibilitySuccess": "Sichtbarkeit des Knotenpunktes {id} geändert",
    "nodeVisibilityError": "Fehler beim Ändern der Sichtbarkeit des Knotenpunktes {id}",
    "nodeVisibilityRestored": "Sichtbarkeit des Knotenpunktes {id} wiederhergestellt",
    "nodePositionSuccess": "Position eines Knotenpunktes geändert",
    "nodePositionError": "Fehler beim Ändern der Position eines Knotenpunktes",
    "nodesPositionsSuccess": "Positionen von Knotenpunkten wurden gerändert",
    "nodesPositionsError": "Fehler beim Ändern der Positionen von Knotenpunkten",
    "nodesOrderSuccess": "Knotenpunktereihenfolge geändert",
    "nodesOrderError": "Fehler beim Ändern der Knotenpunktereihenfolge",
    "nodeHiddenSuccess": "Punkt erfolgreich ausgeblendet",
    "nodeHiddenError": "Fehler beim Ausblenden des Punktes",
    "nodeLockedSuccess": "Punkt ist erfolgreich gesperrt",
    "nodeLockedError": "Fehler beim Sperren des Punktes",
    "layerHiddenSuccess": "Ebene erfolgreich ausgeblendet",
    "layerHiddenError": "Fehler beim Ausblenden der Ebene",
    "layerLockedSuccess": "Ebene ist erfolgreich gesperrt",
    "layerLockedError": "Fehler beim Sperren der Ebene",
    "templateApplySuccess": "Vorlage erfolgreich angewendet",
    "templateApplyError": "Fehler beim Anwenden einer Vorlage",
    "templateRestoreSuccess": "Vorlage erfolgreich wiederhergestellt",
    "templateRestoreError": "Fehler beim Wiederherstellen eines Templates",
    "templateCreateSuccess": "Vorlage wurde erfolgreich erstellt",
    "templateCreateError": "Fehler beim Erstellen einer Vorlage",
    "templateNamedCreateSuccess": "Vorlage {name} wurde erstellt",
    "templateNamedCreateError": "Fehler beim Erstellen der Vorlage {name}",
    "templateUpdateSuccess": "Vorlage wurde erfolgreich aktualisiert",
    "templateUpdateError": "Fehler beim Aktualisieren der Vorlage",
    "templateNamedUpdateSuccess": "Die Vorlage {name} wurde aktualisiert",
    "templateRemoveSuccess": "Die Vorlage wurde gelöscht",
    "templateRemoveError": "Fehler beim Löschen der Vorlage",
    "edgeCreateSuccess": "Linie {id} wurde erstellt",
    "edgeCreateError": "Fehler beim Erstellen einer Linie",
    "edgeRemoveSuccess": "Linie {id} wurde gelöscht",
    "edgeRemoveError": "Fehler beim Löschen der Linie",
    "edgesRemoveSuccess": "Alle Linien wurden gelöscht",
    "edgesRemoveError": "Fehler beim Löschen der Linie",
    "edgesRelatedRemoveSuccess": "Verbindungslinie wurden gelöscht",
    "edgesRelatedRemoveError": "Fehler beim Löschen verbundener Linie",
    "edgeDesignSuccess": "Design von Verbindungslinie {id} aktualisiert",
    "edgeDesignError": "Fehler beim Aktualisieren des Designs von Linie {id}",
    "edgeContentSuccess": "Beschriftung von Linie {id} aktualisiert",
    "edgeContentError": "Fehler beim Aktualisieren der Beschriftung von Linie {id}",
    "edgeVisibilitySuccess": "Sichtbarkeit einer Linie aktualisiert",
    "edgeVisibilityError": "Fehler beim Aktualisieren der Sichtbarkeit einer Linie",
    "edgeVisibilityRestored": "Kantensichtbarkeit wiederhergestellt",
    "globalUpdateSuccess": "Globales Design aktualisiert",
    "globalUpdateError": "Fehler beim Aktualisieren des globalen Designs",
    "mapSettingsSuccess": "Map-Einstellungen aktualisiert",
    "mapSettingsError": "Fehler beim Aktualisieren der Map-Einstellungen",
    "userLanguageSuccess": "Sprache erfolgreich geändert",
    "userLanguageError": "Fehler beim Ändern der Sprache",
    "translatedUnchecked": "Hinweis! Die Sprach-Checkboxen weiterer Sprachen wurden noch nicht ausgefüllt.",
    "translationsCare": "Bitte achten Sie sorgfältig auf Ihre Übersetzungen",
    "downloadMediaSuccess": "Mediendatei erfolgreich heruntergeladen",
    "downloadMediaError": "Fehler beim Herunterladen der Mediendatei"
  },
  "shortcuts": {
    "title": "Tastenkürzel",
    "close": "Schließen",
    "hint": "? drücken, um dieses Fenster ein-/auszublenden",
    "keys": {
      "ctrl": "Strg",
      "cmd": "⌘",
      "shift": "Umschalt",
      "enter": "Enter",
      "esc": "Esc",
      "del": "Entf",
      "space": "Leertaste",
      "drag": "Ziehen",
      "click": "Klick"
    },
    "groups": {
      "canvas": "Arbeitsfläche",
      "title": "Punkttitel",
      "help": "Hilfe"
    },
    "items": {
      "delete": "Ausgewählte(n) Punkt(e) löschen",
      "deselect": "Auswahl aufheben",
      "duplicate": "Punkt duplizieren",
      "selectAll": "Alle Punkte auswählen",
      "nudge": "Punkt verschieben (Umschalt für größere Schritte)",
      "editTitle": "Punkttitel bearbeiten",
      "pan": "Map verschieben",
      "extendSelection": "Punkt zur Auswahl hinzufügen / entfernen",
      "lasso": "Punkte mit Lasso auswählen",
      "lineBreak": "Zeilenumbruch einfügen",
      "nbsp": "Geschütztes Leerzeichen einfügen",
      "softHyphen": "Bedingten Trennstrich einfügen",
      "bold": "Fett umschalten",
      "italic": "Kursiv umschalten",
      "toggle": "Dieses Fenster ein-/ausblenden"
    }
  },
  "quickEditBar": {
    "kaia": {
      "tooltip": "Inhalt mit Ihrem verbundenen LLM erzeugen",
      "tooltipFacts": "Kernfakten mit Ihrem verbundenen LLM erzeugen",
      "tooltipReferences": "Quellen mit Ihrem verbundenen LLM erzeugen",
      "unavailable": "Kein LLM verbunden. Bitten Sie eine Administratorin oder einen Administrator, in den API-Einstellungen eines zu verbinden, um Inhalte zu erzeugen.",
      "failed": "Inhaltserzeugung fehlgeschlagen. Verbinden Sie ein LLM in den API-Einstellungen oder schreiben Sie den Inhalt manuell."
    },
    "nav": "Navigation:",
    "prev": "Vorheriger",
    "next": "Nächster",
    "visibilityFrom": "Sichtbar ab:",
    "visibilityOn": "Sichtbarkeit an:",
    "linkNode": "Verlinke den Punkt mit:",
    "linkBlocked": "Einem Punkt können nicht zugleich Inhalte hinzugefügt und direkt verlinkt werden. Um Inhalte hinzuzufügen, lösche bitte zuerst die URL des Direktlinks.",
    "textStart": "Beschriftung Anfang",
    "textEnd": "Beschriftung Ende",
    "moreOptions": "Mehr Optionen",
    "size": "Größe",
    "fontColor": "Schriftfarbe",
    "contentNotSaved": "Inhalt nicht gespeichert.<br>Bitte speichern oder verwerfen:",
    "shapeSettings": "Form Einstellungen",
    "nodeAppearance": "Punktdesign",
    "fontSettings": "Schrift Einstellungen",
    "titleShortcuts": "Kurzbefehle — Umschalt+Enter: Zeilenumbruch, Strg+Umschalt+Leertaste: geschütztes Leerzeichen, Strg+-: bedingter Trennstrich, Strg+B / Strg+I: fett / kursiv",
    "tooltips": {
      "noBold": "Fett nicht verfügbar",
      "noItalic": "Kursiv nicht verfügbar",
      "noBoldItalic": "Kein `fett kursiv` verfügbar"
    }
  },
  "popup": {
    "sidebar": {
      "title": {
        "content": "Map-Inhalte verwalten",
        "web": "Web Einstellungen verwalten",
        "client": "Nutzerkonto Einstellungen",
        "user": "Nutzereinstellungen",
        "map": "Map-Einstellungen"
      },
      "section": {
        "content": {
          "mediaAssets": "Medienverwaltung"
        },
        "web": {
          "social": "Soziale Netzwerke",
          "cookie": "Cookie Consent",
          "seo": "SEO",
          "url": "Map-URL",
          "access": "Zugangsbeschränkung",
          "embed": "Code einbetten"
        },
        "client": {
          "general": "Allgemeine Einstellungen",
          "user": "Nutzerverwaltung",
          "analytics": "Analytics-Einstellungen",
          "api": "API verwalten",
          "invoices": "Rechnungen",
          "billing": "Zahlungsinformationen",
          "subscription": "Lizenz verwalten",
          "payment": "Zahlungseinstellungen"
        },
        "user": {
          "profile": "Profil",
          "password": "Passwort"
        },
        "map": {
          "settings": "Allgemeine Map-Einstellungen",
          "versions": "Map-Versionen"
        },
        "templates": {}
      }
    },
    "testingPeriod": {
      "title": "Wie die Zeit verfliegt!",
      "description": "Dein kostenfreier Testzeitraum für {package} ist abgelaufen. Kaufe jetzt eine Lizenz, um weiter an Deinen Maps zu arbeiten.",
      "package": {
        "singleLicense": "Einzellizenz"
      }
    },
    "askAdmin": {
      "title": "Admin kontaktieren.",
      "description": "Sie haben keinen Zugriff auf diese Funktion. Bitten Sie Ihren Administrator um Hilfe.",
      "button": "Admin kontaktieren",
      "message": {
        "success": "Nachricht erfolgreich gesendet!",
        "error": "Fehler beim Senden der Nachricht!"
      }
    },
    "choosingLang": {
      "title": "Wähle die Standardsprache:",
      "description": "In welcher Sprache möchtest Du Deine KontextMap starten.",
      "note": "Weitere Sprachen kannst Du später in den allgemeinen Map-Einstellungen hinzufügen.",
      "button": "Starten"
    },
    "translationsOverview": {
      "overview": {
        "title": "Übersicht und Fortschritt der Übersetzungen",
        "table": {
          "text": "Zu übersetzende Texte",
          "defaultLanguage": "Standardsprache",
          "defaultLabels": "Standardbeschriftungen"
        },
        "message": {
          "warning": "Standardbeschriftungen sind nur auf Englisch verfügbar. Bitte Übersetzungen für Standardsprache hinzufügen."
        }
      },
      "labels": {
        "defaultLabels": {
          "title": "Standardbegriffe",
          "tooltip": "Standardbegriffe bezeichnen in der Live-Map bestimmte Bereiche und Sektionen."
        },
        "additionalSources": {
          "title": "Zusätzliche Quellen",
          "tooltip": "Wenn bei den Quellen neben einer BibTeX-Datei zusätzliche Quellen hinterlegt werden, werden diese mit der Überschrift „zusätzliche Quellen“ von den Anderen getrennt."
        },
        "bibtexSources": {
          "title": "Sammlung und Übersicht von Quellen in einer BibTeX-Datei",
          "tooltip": "Diese Überschrift steht über einer Liste von Quellen im Inhaltsverzeichnis, welche aus einer BibTeX-Datei extrahiert werden. Wenn Quellen mit einem BibTeX-Datei hochgeladen werden, erscheinen alle darin enthaltenen Inhalte automatisch in dieser Liste."
        },
        "editorsNote": {
          "title": "Editorial",
          "tooltip": "Dieser Begriff steht auf einem Reiter am Fuße der Map, mit dem ein Editorial mit allgemeinen Informationen zum Projekt, geöffnet werden kann."
        },
        "glossary": {
          "title": "Glossar",
          "tooltip": "Wenn ein Glossar geführt wird, erscheint dieser Begriff als Kategorie im Inhaltsverzeichnis. Darunter werden alle Begriffe und deren Definitionen in einer Liste geführt."
        },
        "interviewPartners": {
          "title": "Interviewpartner",
          "tooltip": "Dieser  Begriff erscheint im Inhaltsverzeichnis, sobald Artikel oder Mediendateien mit entsprechenden Shortcode als „Interviewpartner“ gekennzeichnet worden ist. Darunter werden alle so gekennzeichneten Personen gelistet."
        },
        "listOfArticles": {
          "title": "Artikelliste",
          "tooltip": "Dieser Begriff beschreibt eine Kategorie des Inhaltsverzeichnisses, in welcher alle Artikel und Themenaspekte gelistet werden."
        },
        "logIn": {
          "title": "Anmelden",
          "tooltip": "Wenn die Map in einem geschützten Bereich veröffentlicht wurde, muss man sich dort anmelden, um auf die Inhalte  zugreifen zu können."
        },
        "logOut": {
          "title": "Abmelden",
          "tooltip": "Wenn man bei einer nichtöffentlichen Map angemeldet ist, kann man sich hierüber abmelden."
        },
        "searchAllResults": {
          "title": " alle Ergebnisse",
          "tooltip": "In der Map-internen Suche wird die Anzahl aller Ergebnisse über den Suchergebnissen angezeigt."
        },
        "searchNoResultsFound": {
          "title": "Keine Ergebnisse gefunden",
          "tooltip": "Wenn in der Map-internen Suche keine Ergebnisse gefunden werden, erscheint dieser Standardtext."
        },
        "searchResultArticle": {
          "title": "Artikel",
          "tooltip": "In der Map-internen Suche wird die Anzahl aller Suchergebnisse in Unterkategorien spezifischer unterteilt. Artikel führt alle Ergebnisse, die in Artikeln erscheinen, Mediendateien führt alle Ergebnisse, welche in Medien erscheinen."
        },
        "searchResultMap": {
          "title": "Map",
          "tooltip": ""
        },
        "searchResultMediaAsset": {
          "title": "Mediendatei",
          "tooltip": "In der Map-internen Suche wird die Anzahl aller Suchergebnisse in Unterkategorien spezifischer unterteilt. Artikel führt alle Ergebnisse, die in Artikeln erscheinen, Mediendateien führt alle Ergebnisse, welche in Medien erscheinen."
        },
        "searchResultNode": {
          "title": "Infopunkt",
          "tooltip": ""
        },
        "searchSeparateTermsByComma": {
          "title": "Begriffe durch Komma trennen",
          "tooltip": "Die Suche kann in dem erweiterten Suchfeld weiter eingegrenzt werden. Der Platzhaltertext in den Formularfeldern gibt einen Hinweis, wie mehrere Begriffe eingegeben werden sollen."
        },
        "searchTerm": {
          "title": "Suchbegriff",
          "tooltip": "Dieser Begriff erscheint als Platzhalter in dem Suchfeld der Map-internen Suche."
        },
        "sources": {
          "title": "Quellen",
          "tooltip": "Wenn ein Quellverzeichnis geführt wird, erscheint im Inhaltsverzeichnis die Kategorie „Quellen“"
        },
        "tableOfContents": {
          "title": "Inhaltsverzeichnis",
          "tooltip": "Dieser Begriff steht als übergeordnete Headline im Inhaltsverzeichnis."
        }
      }
    },
    "mapTemplates": {
      "projectName": "Projektnamen eingeben",
      "create": "Map erstellen",
      "createBlanc": "Neues Map-Projekt starten",
      "createTemplate": "Neue Map-Vorlage erstellen",
      "preview": "Vorschau",
      "selectTemplate": "Map-Vorlage auswählen",
      "selectWarningTop": "Diese Map-Vorlage wählen",
      "selectWarningBottom": "Bitte zuerst eine Live-Version erstellen",
      "editTemplate": "Map-Vorlage bearbeiten",
      "deleteTemplate": "Map-Vorlage löschen",
      "templateName": "Name der Map-Vorlage eingeben",
      "cancel": "Abbrechen",
      "allTemplates": "Alle Map-Vorlagen",
      "myTemplates": "Meine Map-Vorlagen",
      "allTitle": "Neues Map-Projekt starten oder Map-Vorlage auswählen",
      "templateTitle": "{type} Vorlagen",
      "themes": {
        "basic": "Basis",
        "process": "Prozess",
        "strategy": "Strategie",
        "business": "Business",
        "marketing": "Marketing",
        "personal": "Eigene",
        "my": "Meine"
      },
      "dimensions": "Größe:",
      "layers": "Ebenen:",
      "palette": "Farbpalette:",
      "section": "Sektion:",
      "templatesTitle": "KontextMaps-Vorlagen",
      "templateCategories": "Vorlagenkategorien",
      "learnMore": "Mehr erfahren",
      "useTemplate": "Vorlage verwenden"
    },
    "duplicate": {
      "doubleLogin": "Double Login!",
      "message": "Unser System meldet, dass Sie mit diesem Benutzerkonto bereits im Map Builder für diese Map angemeldet sind. Haben Sie diese Map im Map Builder in einem anderen Browser oder einem anderen Tab geöffnet?",
      "back": " Wenn ja: Bitte schließen Sie dieses.",
      "reload": " Wenn nicht: Bitte laden Sie diese Seite neu.",
      "buttons": {
        "back": "Bring mich zurück",
        "reload": "Seite neu laden"
      }
    },
    "confirm": {
      "cannotUndone": "Dies ist unwiderruflich.",
      "canUndo": "Mit der Schaltfläche „Rückgängig“ können Sie dies rückgängig machen.",
      "youSure": "Bist Du sicher?",
      "stopMe": "Nein!",
      "sure": "Ja, bitte löschen!",
      "warning": "Willst du diesen {action} ",
      "quotaReached": "Du hast die maximale Anzahl {type} erreicht. Bitte kontaktiere uns via: {email}, um weitere {type} zu buchen.",
      "quotaLiveMapsReached": "Du kannst keine weiteren Live-Maps veröffentlichen. Schalte ein anderes Projekt offline oder hol Dir ein Lizenzupgrade.",
      "quotaLiveMapsReachedAdmin": "Du kannst keine weiteren Live-Maps veröffentlichen. Deaktivieren Sie ein anderes Projekt oder wenden Sie sich an einen Administrator, um Ihren Plan zu aktualisieren.",
      "quotaType": {
        "template": "Templates",
        "map": "Map-Projekte"
      },
      "showMessage": "Nachricht nicht mehr anzeigen.",
      "publishedMapDeleteWarning": "Hiermit löschst Du die Live-Map dieses Projekts. Dir bleibt die letzte Arbeitsversion der Map erhalten. Möchtest Du fortfahren?",
      "noLiveVersion": "Diese Map hat keine Live-Version. Bitte aktiviere sie zuerst als Live in der Map-Übersicht.",
      "actions": {
        "deleteClient": "einen Kunden löschen.",
        "deactivateClient": "einen Kunden deaktivieren.",
        "deleteMap": "Map löschen.",
        "deleteNode": "Punkt löschen.",
        "deleteLayer": "Ebene löschen.",
        "deleteEdge": "Verbindungslinie löschen.",
        "deleteEdges": "alle Verbindungslinien löschen.",
        "deleteAsset": "Mediendatei löschen.",
        "resetMap": "die Map zurücksetzen.",
        "deselectProject": "Projekt offline schalten",
        "upgradePlan": "Lizenzupgrade",
        "deleteLiveMap": "Ja! Löschen!",
        "keepLiveMap": "Oh Nein! Halt mich zurück!",
        "confirm": "Machen wir’s so",
        "cancel": "Vielleicht später",
        "deleteRelatedEdges": "Bestätigen und Linien löschen",
        "cancelDeleteRelatedEdges": "Neeeeiiiiiiiiiiin!!",
        "deletePackage": "ein Paket löschen."
      },
      "tocWarning": "Dieser Punkt ist in der individuellen Reihenfolge des Inhaltsverzeichnisses enthalten.",
      "deleteAndManageToc": "Löschen & im Inhaltsverzeichnis verwalten",
      "tocDeletedNodesAlert": "Achtung: Einige Punkte in der individuellen Reihenfolge wurden gelöscht und müssen verwaltet werden.",
      "largeScreens": "Der Map Builder ist für größere Bildschirme optimiert. Wir arbeiten an einer eingeschränkten Mobilversion",
      "switchScreen": "Um deine Maps zu verwalten, wechsle bitte zu einem größeren Bildschirm.",
      "deleteEdgesNotOverlappedMessage": "Ebenenkonflikt! Eine oder mehrere Verbindungslinien zu dem Punkt, dessen Ebeneneinstellung Du gerade ändern willst, können nicht mehr mit dem Punkt verbunden sein und würden ins Leere laufen.",
      "liveMapSeats": {
        "title": "Alle Live-Map-Plätze vergeben.",
        "options": "Du hast zwei Möglichkeiten:",
        "overview": "1. gehe zur Map-Übersicht und deaktiviere den Live-Status eines anderen Projektes, oder",
        "upgrade": "2. schreib unserem Vertriebsteam, um deine Lizenz zu erweitern.",
        "upgradeViaAdmin": "2. schreib einem Administrator, damit er die Lizenz erweitert.",
        "buttons": {
          "overview": "Map-Übersicht",
          "sales": "Kontakt Vertrieb",
          "admin": "Admin kontaktieren"
        }
      }
    },
    "content": {
      "title": "Eingabefeld für Inhalte",
      "desc": "Hier findest du die Inhalte aller Knotenpunkte der Map.",
      "label": {
        "node": "Knotenpunkt",
        "title": "Titel",
        "type": "Inhaltebox",
        "typeShort": "Inhaltebox",
        "link": "Direktlink",
        "content": "Inhalt",
        "info": "Weitere Informationen",
        "nav": "Navigation unter dem Inhalt:",
        "prevNode": "Vorangehender Knotenpunkt",
        "nextNode": "Nächster Knotenpunkt",
        "terms": "Suchbegriffe",
        "seo": "Kurze Inhaltsbeschreibung für SEO"
      },
      "placeholder": {
        "title": "Name des Punktes",
        "url": "URL hinzufügen",
        "terms": "Suchbegriffe mit Kommas getrennt",
        "seo": "Hier eine Kurzbeschreibung mit 250 Zeichen eingeben."
      },
      "button": {
        "save": "Inhalt des Knotenpunkts speichern",
        "translate": "Übersetzen mit DeepL",
        "discard": "Verwerfen und verlassen"
      },
      "message": {
        "error": "Fehler beim Ändern des Inhalts des Knotenpunkts!",
        "unsaved": "Die Inhalte sind noch nicht gespeichert. Wenn du nicht speicherst, gehen alle Änderungen verloren. Bist du dir sicher?"
      },
      "sources": {
        "label": "Quelldokumente",
        "hint": "Für diesen Punkt generierte Texte stützen sich auf diese Dokumente. Leserinnen und Leser sehen sie nie, und sie werden nie zitiert.",
        "none": "Diesem Punkt ist noch kein Dokument angehängt.",
        "attach": "Datei anhängen",
        "attachLink": "Link anhängen",
        "linkLabel": "Adresse der Seite, die angehängt werden soll",
        "linkPlaceholder": "https://…",
        "addLink": "Anhängen",
        "cancel": "Abbrechen",
        "remove": "{name} löschen",
        "confirmRemove": "{name} löschen?",
        "delete": "Löschen",
        "untitled": "Angehängtes Dokument",
        "reading": "Das Dokument wird gelesen …",
        "failed": "Dieses Dokument konnte nicht gelesen werden.",
        "fromDeletedPoint": "Von einem gelöschten Punkt",
        "actionFailed": "Das hat nicht geklappt. Bitte versuche es noch einmal.",
        "unavailable": "Kein LLM verbunden. Bitte eine Administratorin oder einen Administrator, in den API-Einstellungen eines zu verbinden, um Dokumente zu nutzen.",
        "title": "Quelldokumente dieses Punkts",
        "close": "Schließen"
      }
    },
    "editors": {
      "title": "Editorial",
      "desc": "Füge dem Map-Projekt ein Editorial hinzu, um den Inhalt, das Projekt oder das Team zu beschreiben.",
      "team": "Stelle die Teammitglieder vor",
      "label": {
        "title": "Titel",
        "editors": "Editorial",
        "name": "Name",
        "desc": "Beschreibung",
        "label": "Label",
        "togglerLabel": "Status"
      },
      "placeholder": {
        "title": "z.B. Editorial und Team",
        "desc": "Kurzer Beschreibungstext",
        "label": "Beschriftung auf der Map"
      },
      "button": {
        "add": "Teammitglied hinzufügen",
        "save": "Editorial speichern"
      },
      "message": {
        "errorLoading": "Fehler beim Laden von Einstellungen!",
        "errorSave": "Fehler beim Ändern von Einstellungen!",
        "success": "Einstellungen erfolgreich geändert!"
      }
    },
    "glossary": {
      "title": "Glossar",
      "desc": "Erkläre wichtige Begriffe aus deiner Map, damit sie besser verstanden werden.",
      "label": {
        "term": "Begriff",
        "alternative": "Alternativen",
        "synonyms": "Synonyme",
        "definition": "Definition"
      },
      "placeholder": {
        "term": "Begriff, der definiert werden soll",
        "alternative": "Mit einem Strichpunkt getrennte Begriffe; erscheinen nicht im Glossar",
        "synonyms": "Durch Strichpunkt getrennt",
        "definition": "Definitionstext"
      },
      "button": {
        "add": "Füge Begriffe hinzu",
        "save": "Glossareinstellungen speichern"
      },
      "message": {
        "errorLoading": "Fehler beim Laden der Glossareinstellungen!",
        "errorSave": "Fehler beim Ändern von Glossareinstellungen!",
        "success": "Einstellungen erfolgreich gespeichert!"
      }
    },
    "references": {
      "title": "Quellenverzeichnis",
      "titleShort": "Quellen",
      "desc": "Veröffentliche die Quellen deiner Recherchen in einem Quellenverzeichnis",
      "label": {
        "name": "Name der Quelle",
        "link": "Link"
      },
      "placeholder": {
        "name": "Name der Quelle",
        "link": "Verweis auf die Quelle"
      },
      "button": {
        "add": "Quelle hinzufügen",
        "save": "Quellenverzeichnis speichern",
        "upload": "BibTeX-Datei hochladen"
      },
      "message": {
        "errorLoading": "Fehler beim Laden der Quellen!",
        "errorSave": "Fehler beim Ändern des Quellenverzeichnisses!",
        "success": "Einstellungen erfolgreich gespeichert!",
        "successFile": "Datei erfolgreich hochgeladen!",
        "errorFile": "Fehler beim Hochladen der Datei!",
        "successFileProblems": "Datei hochgeladen. Die Karte zeigt einige Quellen anders als in der Datei – siehe den Hinweis daneben."
      },
      "problems": {
        "summary": "Die Karte zeigt {count} Quelle anders als in der Datei: | Die Karte zeigt {count} Quellen anders als in der Datei:",
        "missing_field": "{entry}: Das Feld „{field}“ fehlt, daher wird die Quelle verkürzt angezeigt",
        "empty": "{entry}: Hat weder Titel noch Autor noch ein anderes Feld, das die Karte anzeigen kann, und wird daher ausgelassen",
        "not_formatted": "{entry}: Konnte nicht formatiert werden und wird daher ausgelassen",
        "other": "{entry}: {message}",
        "more": "… und {count} weitere",
        "unreadable": "Die Datei kann nicht gelesen werden, daher zeigt die Karte keine Quellen. Bitte lade eine korrigierte Datei hoch. Details: {message}"
      }
    },
    "header": {
      "title": "Kopfzeile",
      "desc": "Füge eine individuelle Kopfzeile zu deiner Map hinzu",
      "design": {
        "bg": "Hintergrund",
        "height": "Höhe der Kopfzeile",
        "logo": "Logo",
        "logoHeight": "Logohöhe in der Kopfzeile",
        "link": "Logo linkt auf URL",
        "color": "Schriftfarbe"
      },
      "label": {
        "title": "Titel",
        "url": "URL",
        "target": "Zielfenster",
        "design": "Design-Einstellungen",
        "floating": "Links in der Kopfzeile",
        "additional": "Zusätzliche Links"
      },
      "placeholder": {
        "title": "Sichtbarer Titel",
        "url": "Gib bitte die URL ein",
        "link": "URL der Website"
      },
      "options": {
        "new": "Neues Fenster",
        "same": "Gleiches Fenster / IFrame",
        "embed": "Fenster, in das die Map eingebettet wird"
      },
      "button": {
        "addAdditional": "Zusätzlichen Link hinzufügen",
        "addFloating": "Freien Link hinzufügen",
        "save": "Einstellungen für die Kopfzeile speichern"
      },
      "message": {
        "success": "Einstellungen erfolgreich geändert!",
        "errorSave": "Fehler beim Ändern der Einstellungen der Kopfzeile!",
        "errorLoading": "Fehler beim Laden der Einstellungen der Kopfzeile!",
        "warningRestore": "Du bist dabei, die vorherige Version der Map wiederherzustellen. Bist Du Dir sicher, dass Du das willst?"
      }
    },
    "tableOfContent": {
      "title": "Inhaltsverzeichnis",
      "desc": "Verwalte hier alle Bereiche des Inhaltsverzeichnisses",
      "subTitle": "Unterkategorien für das Inhaltsverzeichnis",
      "label": {
        "show": "Anzeigen",
        "individual": "individuelle Reihenfolge"
      },
      "articles": {
        "desc1": "Ziehe die Artikel von der rechten Spalte in die ",
        "desc2": "linke Spalte ",
        "desc3": "und passe die Reihenfolge durch Drag & Drop an. Sie können bis zu vier Hierarchiestufen erstellen.",
        "individual": "Individuelle Reihenfolge des Inhaltsverzeichnisses",
        "unsorted": "Unsortierte Liste aller Artikel"
      }
    },
    "media": {
      "title": "Medienverwaltung",
      "titleTemplates": "Medienvorlagen",
      "titleDetails": "Dateiinformationen:",
      "label": {
        "templates": "Dateivorlagen",
        "container": "Wo soll diese Datei ausgespielt werden?",
        "small": "Schmale seitliche Leiste",
        "wide": "Breite seitliche Leiste",
        "detached": "Freistehende Inhaltebox",
        "icon": "Symbol auf der Map",
        "bg": "Hintergrundbild",
        "desc": "Was beschreibt die Datei am besten?",
        "photo": "Fotografie",
        "portrait": "Portrait",
        "graphic": "Infografik",
        "drawing": "Zeichnung",
        "illustration": "Illustration",
        "animation": "Animation",
        "film": "Film",
        "voice": "Audio gesprochen",
        "music": "Musik",
        "author": "Autor",
        "title": "Titel",
        "contact": "Kontaktinformationen",
        "copyright": "Copyright",
        "dateCreation": "Erstellt am",
        "authorText": "Text für den Autor",
        "summary": "Kurzzusammenfassung",
        "keywords": "Schlüsselwörter",
        "searchTerms": "Suchbegriffe (Schlüsselworte werden in der Suche priorisiert)",
        "datePublication": "Veröffentlicht am",
        "source": "Quelle",
        "categories": "Kategorie (vordefinierte Hierarchie)"
      },
      "placeholder": {
        "author": "Namen eingeben",
        "title": "Titel eingeben",
        "contact": "Information eingeben",
        "copyright": "Copyright eingeben",
        "dateCreation": "JJJJ-MM-DD SS:MM:SS",
        "authorText": "Hier eingeben",
        "summary": "Hier eingeben",
        "keywords": "Schlüsselwörter eingeben",
        "searchTerms": "Suchbegriffe eingeben",
        "voice": "Text eingeben",
        "datePublication": "JJJJ-MM-DD SS:MM:SS",
        "source": "Text eingeben",
        "categories": "Text eingeben",
        "categoriesTranslate": "Übersetzung hinzufügen"
      },
      "button": {
        "upload": "Neue Datei hochladen",
        "back": "Zurück zur Übersicht",
        "copy": "Medien-URL kopieren",
        "update": "Info aktualisieren",
        "uploadFile": "Datei hochladen"
      },
      "message": {
        "errorUpload": "Etwas ist schief gelaufen!",
        "update": "Erfolgreich aktualisiert",
        "paste": "Ausgewählte URL des Bildes fertig zum Einfügen",
        "errorLoading": "Etwas ist schief gelaufen. Bitte erneut versuchen!",
        "sizeExceeded": "Dateigröße überschritten",
        "invalidLottie": "Diese JSON-Datei ist keine gültige Lottie-Animation.",
        "categoryCreateError": "Die Kategorie konnte nicht angelegt werden."
      },
      "upload": {
        "overview": "Übersicht maximal möglicher Dateigrößen",
        "fileLimit": "maximal {size} MB pro Datei.",
        "noLimit": "Keine Limits",
        "video": "Videodateien",
        "videoOptimal": "Optimale Einstellung: Mit HEVC (h.265) rendern",
        "images": "Bilddateien",
        "vector": "Vektorbasierte Web-Formate",
        "audio": "Audiodateien",
        "other": "Alle anderen Dateitypen"
      }
    },
    "mediaList": {
      "header": {
        "name": "Dateinamen",
        "check": "Datei prüfen"
      },
      "message": {
        "accepted": "Fertig für den Upload",
        "denied": "Dateigröße überschritten.\n Diese Datei kann nicht hochgeladen werden."
      },
      "uploadButton": "Datei hochladen"
    },
    "social": {
      "title": "Symbole teilen",
      "desc": "Sharing-Menü auswählen. Alle ausgewählten Optionen erscheinen automatisch auf der Map.",
      "message": {
        "errorLoading": "Fehler beim Laden der Social-Network-Einstellungen!",
        "errorSave": "Fehler beim Ändern der Social-Network-Einstellungen!",
        "success": "Einstellungen erfolgreich geändert!"
      }
    },
    "cookie": {
      "title": "Cookie Consent",
      "desc": "Cookie Consent zum Map-Projekt hinzufügen.",
      "label": {
        "activate": "Cookie Consent aktivieren",
        "essentialLabel": "Notwendige Cookies",
        "essentialDescription": "Beschreibung für notwendige Cookies",
        "externalLabel": "Externe Quellen zulassen",
        "externalDescription": "Beschreibung für externe Medien",
        "statisticsLabel": "Statistiken",
        "statisticsDescription": "Statistik Beschreibung",
        "imprintLabel": "Impressum-URL",
        "policyLabel": "Datenschutzbestimmungen-URL"
      },
      "placeholder": {
        "link": "Eigene Datenschutzrichtlinie verlinken. Sollte hier nichts verlinkt sein, wird automatisch die Standard-Datenschutzrichtlinie von Kontextlab verlinkt."
      },
      "message": {
        "errorLoading": "Fehler beim Laden der Cookie-Consent-Einstellungen!",
        "errorSave": "Fehler beim Ändern der Cookie-Consent-Einstellungen!",
        "success": "Einstellungen erfolgreich geändert!"
      }
    },
    "seo": {
      "title": "SEO",
      "desc": "Zusätzliche Beschreibung hinzufügen, damit Suchmaschinen dein Projekt besser finden können.",
      "label": {
        "desc": "Beschreibung",
        "url": "URL für eingebundene Map"
      },
      "info": {
        "url1": "Für die Suchmaschinenoptimierung ist es wichtig, dass die korrekte URL beim veröffentlichen der Map ausgewählt wird. Die verfügbaren URLs können von der Veröffentlichen-Seite kopiert werden.",
        "url2": "Jedoch hat das Einbetten einer solchen URL in einen IFrame oder als Einbett-Code einen negativen Effekt auf die Suchmaschinenoptimierung.",
        "url3": "Für optimale Suchergebnisse ist die Verwendung einer CNAME-Domain die beste Wahl."
      },
      "placeholder": {
        "desc": "Kurzbeschreibung deines Map-Projekts. Im besten Fall 120 – 160 Zeichen.",
        "url": "URL der Seite, auf welcher die Map eingebunden wird"
      },
      "message": {
        "errorLoading": "Fehler beim Laden der SEO-Einstellungen!",
        "errorSave": "Fehler beim Ändern der SEO-Einstellungen!",
        "success": "Einstellungen erfolgreich geändert!"
      }
    },
    "url": {
      "title": "Map-spezifische URL",
      "desc": "Kopiere die URL des Projekts oder passe sie individuell mit einem „Identifier“ an.",
      "label": {
        "usage": "Verwendung auf",
        "usageSub": "Verwendung auf Subdomain des Kunden",
        "usageCNAME": "Verwendung mit CNAME-URL",
        "url": "URL Identifier"
      },
      "info": {
        "default": "Standard-Map-URL",
        "personalized": "Personalisierte Map-URL",
        "manageSubdomain": "Die Subdomain dieser individuellen URL kannst du in den allgemeinen",
        "customizeID": "Passe die individuelle URL-Kennung für dieses Projekt mit dem URL Identifier an (Das ist die spezifische Kennzeichnung am Ende der URL).",
        "defaultID": "Als Standardkennung wird hier der <span class=\"font-weight--500\">{id}</span> verwendet:",
        "urlCustom": "Der hinterste Teil der URL kann mittels „URL Identifier“ weiter unten angepasst werden",
        "usageSub": "Als alternative, kürzere URL-Variante kann auch eine kundenspezifische URL verwendet werden, die bereitgestellt wird",
        "usageCNAME": "Öffentliche Maps verwenden diese URL, um sie für Suchmaschinen zu optimieren. Alle Maps, die nicht frei zugänglich sein sollen, müssen eine alternative URL haben, um die Zugangsbeschränkungen aktiv zu halten.",
        "noSubdomain": {
          "createOptions": "Erstelle eine individuelle und verkürzte URL für deine Map. Je nach Paket stehen dir zwei Optionen zur Verfügung:",
          "subdomain": "1. Eine individuelle kontextmaps Subdomain",
          "or": "oder",
          "cname": "2. eine Übertragung der Map auf eine eigene Domain bzw. Subdomain via CNAME.",
          "note": "Bitte beachte: Es kann jeweils nur eine dieser beiden Optionen eingerichtet werden. Die individuellen Domaineinstellungen gelten für alle Map-Projekte in deinem Account. Die URL-Kennung je Map-Projekt kannst du mit dem URL Identifier individuell gestalten.",
          "noURL": "Es liegt noch keine individuelle URL-Einstellung vor. Wähle eine der beiden Optionen in den",
          "linkSettings": "allgemeinen Account Einstellungen",
          "setURL": "Anschluss kannst du hier die individuelle URL-Kennung für dieses Projekt hier einstellen:"
        }
      },
      "placeholder": {
        "url": "URL spezifizieren"
      },
      "message": {
        "success": "Einstellungen erfolgreich gespeichert!",
        "errorLoading": "Fehler beim Laden von URL-Detaileinstellungen!",
        "errorSave": "Fehler beim Ändern von URL-Detaileinstellungen!",
        "paste": "Link in die Zwischenablage kopiert!",
        "errorPaste": "Kann nicht in die Zwischenablage kopiert werden! Bitte manuell kopieren."
      }
    },
    "access": {
      "title": "Zugangsbeschränkung",
      "desc": "Wähle ob dein Map-Projekt öffentlich zugänglich oder zugangsbeschränkt für ausgewählte Nutzergruppen sein soll.",
      "options": {
        "limited": "eingeschränkter Zugang",
        "partial": "Zugang nach Registrierung",
        "accessible": "öffentlich zugänglich"
      },
      "label": {
        "access": "Zugangsbeschränkung",
        "additional": "Zusätzliche Einschränkungen",
        "callEmbedded": "Kann nur eingebettet aufgerufen werden",
        "clickablePoints": "Anzahl freier Popups",
        "loginForm": "Text für das Anmeldefenster",
        "registerForm": "Text für das Registrierfenster",
        "consent": "Text für die Zustimmung bei der Registrierung",
        "consentRequired": "Zustimmung bei der Registrierung ist notwendig",
        "allowEmbedded": "Eingebettete Domains erlauben"
      },
      "placeholder": {
        "allowEmbedded": "Eine Domain oder Subdomain pro Zeile, z.B.\nbeispiel.de oder kontext.beispiel.de"
      },
      "message": {
        "success": "Einstellungen erfolgreich gespeichert!",
        "errorLoading": "Fehler beim Laden der Zugangsbeschränkungs-Einstellungen!",
        "errorSave": "Fehler beim Ändern der Zugangsbeschränkungs-Einstellungen!"
      }
    },
    "embed": {
      "title": "Einbett-Code",
      "desc": "Einbetten deines Map-Projekts in einer bestehenden Website.",
      "label": {
        "iframe": "Um die Map auf deiner Website mittels IFrame einzubetten, bitte den folgenden Code dort einbinden, wo die Map erscheinen soll:",
        "preview": "Du kannst die Map auch mit einem Vorschaubild einbinden. Das Vorschaubild wird auf deiner Website dargestellt und sobald du darauf klickst, öffnet sich die Map im Browserfenster. Dafür bitte erst ein Vorschaubild in der Medienverwaltung hochladen, das den Namen vorschau.jpg oder vorschau.png trägt. Anschließend den folgenden Code kopieren und auf deiner Website einfügen:"
      },
      "message": {
        "paste": "Link in die Zwischenablage kopiert!",
        "errorLoading": "Fehler beim Laden der Einbett-Code-Einstellungen!",
        "errorPaste": "Kann nicht in die Zwischenablage kopiert werden! Bitte manuell kopieren."
      }
    },
    "general": {
      "title": "Allgemeine Einstellungen",
      "desc": "Profil- und allgemeine Domain-Einstellungen ändern.",
      "label": {
        "profile": "Profil",
        "company": "Firmenname",
        "logo": "Logo",
        "logoText": "Hinweis für Login-Seite",
        "domain": "Domain-Einstellungen",
        "cname": "CNAME-Domain",
        "subdomain": "Deine KontextMaps-Subdomain"
      },
      "info": {
        "settings": "Verwalte hier deine individuelle und verkürzte Stammdomain, die für alle deine Map-Publikationen gilt.",
        "settingsNote": "Bitte beachte: Es kann jeweils nur eine dieser beiden Optionen eingerichtet werden.",
        "cname": "Erstelle eine individuelle Subdomain bei deinem Webhoster und stelle die Domain-Einstellungen auf CNAME, damit Kontextlab diese Domain für das Einbetten der Map verwenden kann.",
        "subdomain": "Durch das Ändern der Subdomain gehen bereits geteilte URLs verloren, was sie für die zukünftige Verwendung unbrauchbar macht."
      },
      "placeholder": {
        "company": "Name",
        "cname": "Hier individuell verbundene CNAME-Domain eintragen z.B. cname.com",
        "subdomain": "z.B. subdomain"
      },
      "button": {
        "upload": "Portrait hochladen"
      },
      "message": {
        "success": "Einstellungen erfolgreich geändert!",
        "errorLoading": "Fehler beim Laden der allgemeinen Domain-Einstellungen!",
        "errorSave": "Fehler beim Ändern der allgemeinen Domain-Einstellungen!"
      }
    },
    "profile": {
      "title": "Profil",
      "desc": "Verwalte dein individuelles Profil.",
      "label": {
        "firstName": "Vorname",
        "surname": "Nachname",
        "email": "E-Mail-Adresse",
        "picture": "Profilbild"
      },
      "placeholder": {
        "firstName": "Name",
        "surname": "Name",
        "email": "E-Mail-Adresse"
      },
      "button": {
        "upload": "Portrait hochladen"
      },
      "message": {
        "success": "Profil erfolgreich geändert!",
        "errorSave": "Fehler beim Ändern der Profileinstellungen!"
      }
    },
    "password": {
      "title": "Passwort",
      "desc": "Passwort verwalten.",
      "label": {
        "password": "Passwort",
        "confirm": "Passwort bestätigen"
      },
      "placeholder": {
        "password": "Mindestens 8 Zeichen",
        "confirm": "Passwort bestätigen"
      },
      "message": {
        "success": "Passwort erfolgreich geändert!",
        "errorSave": "Etwas ist schief gelaufen"
      }
    },
    "mapGeneral": {
      "title": "Allgemeine Map-Einstellungen",
      "desc": "Verwalte die allgemeinen Informationen deines Map-Projekts.",
      "settingsTitle": "Einstellungen für die Live-Map-Ansicht",
      "label": {
        "project": "Name des Map-Projekts",
        "desc": "Beschreibung",
        "terms": "Suchbegriffe",
        "section": "Sparte",
        "palette": "Farbpalette",
        "preview": "Vorschaubild",
        "favicon": "Favicon",
        "premium": "Premium template",
        "templateDescription": "Kurzbeschreibung der Vorlage",
        "templateDescriptionUrl": "URL zur detaillierten Vorlagenbeschreibung (optional)",
        "templateCategory": "Vorlagenkategorie"
      },
      "placeholder": {
        "project": "Name der Map",
        "desc": "Kurzbeschreibung über den Inhalt der Map",
        "terms": "Suchbegriffe durch Kommas getrennt",
        "section": "z.B. business",
        "palette": "z.B. ocean",
        "templateDescription": "Kurze Beschreibung der Map-Vorlage, max 150 Zeichen",
        "templateDescriptionUrl": "URL zur externen Vorlagenbeschreibung"
      },
      "message": {
        "errorSave": "Fehler beim Ändern der Map-Einstellungen!",
        "success": "Map-Einstellungen erfolgreich gespeichert!"
      },
      "button": {
        "favicon": "Favicon hochladen",
        "preview": "Vorschau hochladen"
      },
      "uploadDescription": {
        "notes": "Hinweise für den Favicon-Bild-Upload:",
        "dimensions": "Bild-Dimension: quadratisch",
        "size": "Bild-Größe: zwischen 128x128px und 512x512px",
        "format": "Dateiformat: .jpg oder .png"
      }
    },
    "mapVersion": {
      "title": "Live-Version",
      "titleProgress": "Map in Bearbeitung",
      "label": {
        "publish": "Hier die jüngste Version veröffentlichen.",
        "lastPublished": "Zuletzt bearbeitet",
        "notPublished": "Live-Version wurde noch nicht veröffentlicht",
        "changed": "Die Map hat sich verändert.",
        "lastLive": "Live-Version zuletzt veröffentlicht"
      },
      "button": {
        "viewProgress": "Map in Bearbeitung anzeigen",
        "reset": "Map in Bearbeitung zurücksetzen",
        "sync": "Zur Live-Version synchronisieren",
        "viewLive": "Live-Version anzeigen"
      },
      "message": {
        "successPublished": "Map erfolgreich veröffentlicht!",
        "errorPublished": "Fehler beim Veröffentlichen der Map!",
        "successReset": "Map erfolgreich zurückgesetzt!",
        "errorReset": "Fehler beim Zurücksetzen der Map!"
      }
    },
    "publishing": {
      "title": "Veröffentliche deine Map",
      "desc": "Eine Schritt-für-Schritt-Anleitung zur Veröffentlichung deiner Map",
      "tooltip": "Übersicht veröffentlichen",
      "blockedOptionTooltip": "Um diese Optionen ändern zu können, ist die Live-Map zwingend erforderlich.",
      "steps": {
        "create": {
          "title": "Live-Version erstellen",
          "description": "Um deine Map zu veröffentlichen, musst du eine Live-Version erstellen. Diese Version unterscheidet sich von der Vorschau-Version: Sie enthält kein „Vorschau“ Label und wird alle weiteren Änderungen erst dann darstellen, wenn du dies aktiv dort hin lädst. Die Versionen Deiner Map kannst Du",
          "descriptionLink": "hier verwalten.",
          "status": {
            "notPublished": "Dieses Map-Projekt hat noch keine Live-Version. Erstelle nun eine Live-Version dieses Projektes, um mit der Veröffentlichung fortfahren zu können.",
            "hasChanges": {
              "changes": "Für dieses Map-Projekt existiert eine Live-Version. Es wurden aber Änderungen vorgenommen.",
              "check": "Bitte überprüfe ",
              "link": "unter Map Versionen,",
              "upload": "ob du diese Änderungen in die aktuelle Live-Version hochladen möchtest.",
              "access": "Oder fahre mit der",
              "accessLink": "Zugriffsverwaltung fort."
            },
            "exist": "Für dieses Map-Projekt existiert eine Live-Version. Die Live-Map ist auf dem aktuellsten Stand.",
            "existLink": "Verwalte nun den Zugriff für diese Map."
          },
          "popup": {
            "noLiveVersionTitle": "Keine Live-Version verfügbar",
            "studentContent": "Für die Veröffentlichung der Map ist eine Live-Version erforderlich. Diese kann nur von Administratoren oder Editoren erstellt werden. Bitte wende dich daher an den Admin, um eine gültige URL zu erhalten."
          },
          "button": {
            "publish": "Als Live-Version veröffentlichen"
          }
        },
        "access": {
          "title": "Zugriff verwalten",
          "descStudent": "Du entscheidest, ob deine Live-Map öffentlich oder nur für eine ausgewählte Gruppe erreichbar ist.",
          "projectAccess": "Dieses Projekt ist aktuell "
        },
        "publish": {
          "title": "Map veröffentlichen",
          "desc": "Wähle einen der drei Optionen, um deine Map zu teilen und zu publizieren:",
          "options": {
            "default": {
              "title": "1. Die Standard-URL",
              "desc": "Jede Map erhält automatisch eine URL. Diese ist immer gültig, unabhängig von den anderen Optionen. Wenn deine Map nicht öffentlich ist, müssen sich eingeladene Besucher über eine Login-Seite anmelden, um auf die Map zugreifen zu können.",
              "url": "Deine Standard-URL lautet:"
            },
            "custom": {
              "title": "2. Deine individuelle Domain",
              "descAdmin": "Damit die URL kürzer wird und um ihr eine eindeutige Kennung zuzuordnen, kannst du entweder eine individuelle KontextMaps-Subdomain einrichten oder die Map per CNAME-Domain auf deine persönliche Domain übertragen.",
              "admin": {
                "manage": "Verwalte",
                "subdomain": "hier die Subdomain",
                "and": "und hier",
                "id": "die Map-Kennung."
              },
              "descStudent": "Damit die URL kürzer wird und um ihr eine eindeutige Kennung zuzuordnen, kann ein Administrator eine individuelle Domain einrichten. Sollen Änderungen vorgenommen werden, ",
              "descStudentLink": "frag bitte deinen Admin.",
              "url": "Die individuelle URL der Map lautet:",
              "noUrl": "Aktuell ist keine individuelle Domain eingerichtet."
            },
            "embed": {
              "title": "3. In deine Webseite einbinden",
              "desc": "Binde die Map direkt mit einem iFrame in deiner Webseite ein. Alternativ kannst du ein Vorschaubild einbinden (wähle hierfür die div-Tag Variante), auf das mit einem Klick die Map im Vollformat geöffnet wird.",
              "link": "Finde hier alle Einbinde-Codes."
            }
          }
        }
      }
    },
    "mapLanguages": {
      "title": "Map-Spracheinstellungen",
      "desc": "Verwalte die Spracheinstellungen dieser Map und erhalte eine Übersicht über alle Übersetzungen.",
      "preview": {
        "title": "Spracheinstellungen für Vorschau- und Live-Map",
        "radio": {
          "auto": "automatisch (wie Browsersprache)",
          "default": "Standardsprache"
        },
        "label": {
          "first": "Welche Sprache soll zuerst angezeigt werden?",
          "default": "Welche ist die Standardsprache?",
          "additional": "Welche zusätzlichen Sprachen sollen hinzufügt werden?",
          "translateWith": "Übersetzen mit",
          "integration": "Wählen Sie die Übersetzungsintegration aus",
          "apiKey": "Ihr API-Schlüssel"
        },
        "placeholder": {
          "additional": "Zusätzliche Sprachen",
          "provider": "Übersetzungsanbieter",
          "apiKey": "Gespeichert; leer lassen, um den aktuellen Schlüssel zu behalten"
        }
      },
      "button": {
        "globalTranslation": "Gesamte Map übersetzen"
      },
      "tooltip": {
        "translated": "Alle Texte übersetzt",
        "notTranslated": "Alle oder einige Texte sind noch nicht übersetzt. Bitte überprüfe die Übersetzungen.",
        "notTranslatedDefault": "Die Standardbeschriftungen sind nur auf Englisch verfügbar. Bitte Übersetzungen für die Standardsprache hinzufügen."
      },
      "message": {
        "targetLanguagesError": "Zusätzliche Sprachen {languages} werden von DeepL nicht unterstützt. Bitte stellen Sie sicher, dass Sie sie manuell übersetzen.",
        "targetLanguageError": "Die zusätzliche Sprache {language} wird von DeepL nicht unterstützt. Bitte stellen Sie sicher, dass Sie es manuell übersetzen.",
        "partialTargetLanguagesError": "{languages} weiterer Sprachen werden von DeepL nicht unterstützt. Bitte stellen Sie sicher, dass Sie sie manuell übersetzen.",
        "partialTargetLanguageError": "{language} oder weitere Sprachen werden von DeepL nicht unterstützt. Bitte stellen Sie sicher, dass Sie es manuell übersetzen.",
        "sourceLanguageError": "Die Sprache {language} wird von DeepL nicht unterstützt",
        "credentialsError": "Bitte überprüfen Sie Ihre Anmeldeinformationen oder versuchen Sie es später erneut."
      }
    },
    "mapProtocol": {
      "title": "Protokoll",
      "desc": "Hier sind alle aktuellen Änderungen gelistet und es können bei Bedarf frühere Versionen wiederherstellt werden.",
      "label": {
        "version": "Versions-ID",
        "date": "Datum",
        "time": "Uhrzeit",
        "editedBy": "Bearbeitet von",
        "typeOfChange": "Art der Änderung",
        "restoreState": "Zustand wiederherstellen"
      }
    },
    "collectedVersions": {
      "title": "Gesammelte Versionen",
      "save": "Aktuellen Zustand der Map speichern",
      "publishLive": "Version als Live-Version veröffentlichen",
      "label": {
        "version": "Versions-ID",
        "date": "Datum",
        "time": "Uhrzeit",
        "saved": "Bearbeitet von",
        "name": "Name der Version",
        "describe": "Zustand der Map beschreiben"
      },
      "message": {
        "error": "Fehler beim Speichern des Zustands"
      }
    },
    "mapSpecific": {
      "access": {
        "none": "Kein Zugriff",
        "read": "Lesen",
        "edit": "Lesen und Bearbeiten"
      },
      "button": {
        "save": "Map-Einstellungen speichern"
      }
    },
    "user": {
      "title": "Nutzerkonten",
      "desc": "Verwalte alle Nutzer deines Map-Projekts.",
      "label": {
        "name": "Name",
        "email": "E-Mail-Adresse",
        "role": "Rolle",
        "password": "Passwort",
        "passwordConfirm": "Passwort bestätigen",
        "premium": "Dies ist eine Premium-Vorlage"
      },
      "placeholder": {
        "name": "Namen hinzufügen",
        "email": "E-Mail-Adresse hinzufügen",
        "password": "Mindestens 8 Zeichen",
        "passwordConfirm": "Passwort bestätigen"
      },
      "button": {
        "add": "Neuen Nutzer hinzufügen",
        "save": "Nutzereinstellungen speichern",
        "remove": "Benutzer löschen",
        "removeCancel": "ich habe meine Meinung geändert"
      },
      "support": {
        "desc": "Zugang des KontextMaps-Support-Teams verwalten",
        "checkbox": "Ich gewähre dem Support-Team Zugriff auf mein Konto und meine Projekte, um Hilfe zu erhalten."
      },
      "message": {
        "removeUser": "Mit dem Löschen des Benutzers fortfahren?",
        "inviteAll": "Bitte laden Sie vor dem Speichern alle Benutzer ein",
        "success": "Nutzerkonto erfolgreich geändert!",
        "errorSave": "Fehler beim Ändern von Nutzerkonteneinstellungen!",
        "errorLoading": "Fehler beim Laden von Nutzerkonteneinstellungen!",
        "emailExists": "Für diese E-Mail-Adresse existiert bereits ein Passwort. Wenn ein neues eingeben wird, wird es automatisch für alle anderen Konten verwendet, die mit dieser E-Mail-Adresse verbunden sind.",
        "quotaReached": "Sie haben das Limit der verfügbaren Plätze erreicht. Um es zu verlängern, wählen Sie bitte das richtige Paket aus."
      }
    },
    "analytics": {
      "title": "Analytics-Einstellungen",
      "desc": "Verbinde die Map mit deinem Analytics-Konto.",
      "label": {
        "code": "Analytics-Code"
      },
      "placeholder": {
        "code": "Google Property ID"
      },
      "message": {
        "success": "Nutzerkonten erfolgreich geändert!",
        "errorSave": "Fehler beim Ändern der Analytics-Einstellungen!",
        "errorLoading": "Fehler beim Laden der Analytics-Einstellungen!"
      }
    },
    "api": {
      "title": "API verwalten",
      "desc": "Verbinden Sie externe Quellen mit Ihrem KontextMap-Konto.",
      "label": {
        "key": "API-Schlüssel",
        "address": "Serveradresse"
      },
      "placeholder": {
        "key": "Geben Sie hier Ihren API-Schlüssel ein",
        "address": "Geben Sie hier die Serveradresse ein",
        "keyStored": "Gespeichert – zum Ersetzen neu eingeben"
      },
      "button": {
        "save": "API-Einstellungen speichern",
        "test": "Verbindung testen"
      },
      "ownModel": {
        "title": "Eigenes LLM",
        "desc": "Verbinden Sie ein eigenes Sprachmodell, um Artikelinhalte für Punkte zu erzeugen.",
        "noneOption": "Nicht verbunden",
        "label": {
          "provider": "Anbieter",
          "model": "Modell",
          "endpoint": "Endpunkt",
          "apiVersion": "API-Version",
          "key": "API-Schlüssel"
        },
        "placeholder": {
          "provider": "Anbieter auswählen",
          "model": "z. B. gpt-4o, mistral-large-latest",
          "endpoint": "Basis-URL des Servers",
          "apiVersion": "z. B. 2024-10-21",
          "key": "Geben Sie den API-Schlüssel des Anbieters ein",
          "keyOptional": "Optional bei On-Premise-Servern"
        },
        "button": {
          "save": "LLM-Einstellungen speichern"
        }
      },
      "field": {
        "api_key": "API-Schlüssel",
        "api_token": "API-Token",
        "client_id": "Anwendungs-ID (Client)",
        "client_secret": "Client-Geheimnis",
        "deployment": "Installation",
        "email": "Konto-E-Mail",
        "integration_token": "Token der internen Integration",
        "permission_scope": "Berechtigungsumfang",
        "server_url": "Serveradresse",
        "site_url": "Website-URL",
        "space_key": "Bereichsschlüssel",
        "tenant_id": "Verzeichnis-ID (Mandant)"
      },
      "fieldPlaceholder": {
        "email": "bot{'@'}firma.de",
        "site_url": "https://firma.sharepoint.com/sites/technik",
        "space_key": "z. B. TECHNIK"
      },
      "help": {
        "api_token": "Cloud: ein Atlassian-API-Token. Data Center: ein persönliches Zugriffstoken.",
        "client_id": "Entra ID → App-Registrierungen → deine App → Übersicht → Anwendungs-ID (Client). Die Registrierung braucht die unten gewählte Anwendungsberechtigung mit Administratorzustimmung.",
        "client_secret": "Entra ID → App-Registrierungen → deine App → Zertifikate & Geheimnisse → Neuer geheimer Clientschlüssel. Kopiere den Wert, nicht die Geheimnis-ID. SharePoint selbst hat keinen API-Schlüssel.",
        "email": "Das Atlassian-Konto, zu dem das API-Token gehört.",
        "integration_token": "Erstelle unter notion.so/my-integrations eine interne Integration und füge deren Secret hier ein. Gib anschließend in Notion jede Seite, die angeboten werden soll, über das Seitenmenü unter „Verbindungen“ für diese Integration frei: **ein funktionierendes Token zeigt nichts an, solange nichts freigegeben wurde.**",
        "permission_scope": "Sites.Read.All erlaubt dieser App den Lesezugriff auf **alle Sites des Tenants**, nicht nur auf die hier konfigurierte — die Site-URL begrenzt, was diese Verbindung anzeigt, nicht was die App lesen darf. Sites.Selected gewährt zunächst nichts: die SharePoint-Administration erteilt den Lesezugriff dann pro Site. Bevorzuge das, außer wenn die Suche über eine große Site nötig ist — dabei wird die Site direkt gelesen, ohne den Suchindex des Tenants und ohne Trefferanzahl.",
        "site_url": "Die auszulesende Site, z. B. https://acme.sharepoint.com/sites/engineering — die Adresse der Site selbst, nicht die einer Seite darin.",
        "space_key": "Es werden nur Seiten aus diesem Space angeboten. Der Key ist das Kürzel aus der Space-URL, z. B. /wiki/spaces/ENG — kein API-Token.",
        "tenant_id": "Entra ID → App-Registrierungen → deine App → Übersicht → Verzeichnis-ID (Mandant)."
      },
      "choice": {
        "deployment": {
          "cloud": "Atlassian Cloud",
          "datacenter": "Data Center / Server (selbst gehostet)"
        },
        "permission_scope": {
          "sites_read_all": "Sites.Read.All — alle Sites des Tenants",
          "sites_selected": "Sites.Selected — nur einzeln freigegebene Sites"
        }
      },
      "noneEnabled": "Für dieses Konto ist noch keine externe Quelle freigeschaltet.",
      "message": {
        "incomplete": "{provider} wurde nicht gespeichert: Fülle {fields} aus.",
        "looksLikeSecret": "{provider} wurde nicht gespeichert: „{field}“ enthält offenbar ein API-Token. Das Token gehört in das Zugangsdaten-Feld dieser Quelle.",
        "testRunning": "Verbindung wird getestet …",
        "testTotal": "Verbunden — {total} Einträge verfügbar.",
        "testSome": "Verbunden — Inhalte wurden geliefert.",
        "testEmpty": "Verbunden, aber die Quelle liefert nichts. Prüfe den Space-Key oder die Site-URL.",
        "testSample": "Erster Eintrag: „{title}“.",
        "testNotEnabled": "Die Zugangsdaten funktionieren. {provider} muss für dieses Konto noch aktiviert werden, damit die Quelle im Map Builder erscheint.",
        "testFailed": "Der Test ist fehlgeschlagen."
      },
      "connection": {
        "label": "Name der Verbindung",
        "placeholder": "z. B. Technik-Wiki",
        "add": "Weitere Verbindung hinzufügen",
        "create": "Verbindung hinzufügen",
        "save": "Verbindung speichern",
        "cancel": "Abbrechen",
        "remove": "Trennen",
        "removeConfirm": "Endgültig trennen",
        "removeHint": "Bereits eingebettete Inhalte dieser Verbindung lassen sich danach nicht mehr auflösen, und der Name wird nie wiederverwendet.",
        "labelRequired": "Gib der Verbindung einen Namen: nur daran lassen sich zwei Verbindungen derselben Quelle unterscheiden.",
        "added": "„{label}“ wurde zu {provider} hinzugefügt.",
        "saved": "„{label}“ wurde gespeichert.",
        "removed": "„{label}“ wurde von {provider} getrennt.",
        "perConnection": "Jede Verbindung dieser Quelle wird einzeln gespeichert."
      },
      "assistant": {
        "title": "KAIA-Assistent",
        "desc": "KAIA führt Autoren durch den Aufbau einer Map. Ausgeschaltet ist er in allen Maps dieses Kontos verborgen; Autoren können ihn zusätzlich für eine einzelne Map in deren allgemeinen Einstellungen ausschalten.",
        "label": "KAIA für dieses Konto einschalten"
      }
    },
    "reports": {
      "title": "Analytics-Berichte",
      "desc": "Verbinde die Map mit deinem Analytics-Konto."
    },
    "invoices": {
      "title": "Rechnungen",
      "desc": "Hier findest du eine Liste mit deinen Rechnungen.",
      "message": {
        "errorLoading": "Fehler beim Laden der Rechnungsdetails!"
      }
    },
    "billing": {
      "title": "Rechnungseinstellungen",
      "desc": "Aktualisiere hier die Einstellungen für deine Rechnung.",
      "label": {
        "company": "Firmenname",
        "email": "E-Mail-Adresse",
        "address": "Adresse",
        "postal": "Postleitzahl",
        "city": "Stadt",
        "state": "Bundesstaat",
        "country": "Land",
        "id": "Umsatzsteuer-ID-Nummer"
      },
      "placeholder": {
        "company": "Name",
        "email": "E-Mail-Adresse hinzufügen",
        "address": "Straßenname",
        "postal": "12345",
        "city": "Stadt",
        "state": "Bundesstaat",
        "id": "DE123456789"
      },
      "message": {
        "success": "Einstellungen erfolgreich geändert!",
        "errorSave": "Fehler beim Ändern der Rechnungseinstellungen!",
        "errorLoading": "Fehler beim Laden der Rechnungseinstellungen!"
      }
    },
    "subscription": {
      "title": "Lizenz verwalten",
      "desc": "Übersicht zur aktuellen Lizenz",
      "overview": {
        "plan": "Aktueller Lizenz Plan:",
        "extension": "Deine Lizenzerweiterungen:",
        "start": "Deine Lizenz startete am:",
        "renew": "Deine Lizenz wird automatisch an diesem Tag erneuert:"
      },
      "manage": {
        "title": "Verwalte deine aktuelle Lizenz",
        "desc": "Im Selbst Service Portal unseres Payment Dienstleisters kannst Du:",
        "list": {
          "adjust": "Deine Rechnungsdaten anpassen",
          "manage": "Deine Zahlungsdaten verwalten",
          "cancel": "Die Lizenz kündigen"
        },
        "button": "Erweiterung kaufen"
      },
      "order": {
        "title": "Lizenz erweitern",
        "desc": "Wähle aus den folgenden Optionen, um Deine Lizenz zu erweitern. Die Abrechnung (jährlich/monatlich) erfolgt entsprechend Deiner aktuellen Lizenz.",
        "extension": {
          "mapCreator": "Zusätzlicher Nutzer (Admin oder Editor)",
          "liveMap": "Zusätzliche Live-Map",
          "storage": "5GB zusätzlicher Medienspeicher"
        },
        "month": "month",
        "button": "Erweiterung kaufen"
      },
      "confirm": {
        "title": "Du bist dabei folgende Lizenz Erweiterungen zu kaufen:",
        "desc": {
          "restart": "Mit dem Kauf der Erweiterungen startet die Laufzeit Deiner Lizenz heute neu:",
          "license": "Neben der Erweiterungen wird daher auch die Lizenz für Deine aktuelle Lizenz neu berechnet. Die bereits bezahlten Lizenzgebühren der ursprünglich verbleibenden Laufzeit werden von der Gesamtsumme abgezogen."
        },
        "total": {
          "period": "Abrechnungsperiode:",
          "extension": "Summe Lizenz Erweiterung,",
          "plan": "Summe Lizenz Plan (Plan-Name),",
          "term": "Abzüglich der Restlaufzeit der aktuellen Lizenz"
        },
        "period": {
          "month": "monatlich",
          "year": "jährlich"
        },
        "invoice": "Der gesamte Rechnungsbetrag ist somit:",
        "button": "Erweiterung kaufen"
      }
    },
    "payment": {
      "title": "Zahlungseinstellungen",
      "desc": "Zahlungseinstellungen verwalten."
    },
    "release": {
      "message": {
        "errorLoading": "Fehler beim Laden der Versionshinweise!"
      }
    },
    "manual": {
      "sidebar": {
        "title": "Hilfe",
        "types": {
          "tour": "Tour durch den Map Builder",
          "manual": "Bedienungsanleitung"
        }
      },
      "content": {
        "title": "Bedienungsanleitungen & Anwendungstouren",
        "description": "Tour auswählen, um die Funktionen des Map Builders kennenzulernen",
        "list": {
          "basicTour": {
            "title": "Basisfunktionen des Map Builders",
            "description": "Kurze, knackige Tour mit den wichtigsten Funktionen"
          },
          "basicStudentTour": {
            "title": "Kurztrip durch die Funktionen:",
            "description": "Eine kurze Einleitung für tolle Wissenslandkarten"
          },
          "baseKnowledge": {
            "title": "Bedienungsanleitung",
            "description": "Eine komplette und umfassende Übersicht aller Funktionen."
          }
        }
      }
    },
    "quizzes": {
      "title": "Quiz Werkzeug",
      "description": "Quiz anlegen und verwalten",
      "createQuiz": "Neues Quiz anlegen",
      "label": {
        "name": "Quizname",
        "description": "Optional: Beschreibung",
        "picture": "Optional - Titelbild für vorangehende Fragen"
      },
      "placeholder": {
        "name": "Name für das Quiz",
        "description": "Optional: Quiz Kurzbeschreibung"
      },
      "checkbox": {
        "expandableList": "Fragen werden in einer ausklappbaren Liste dargestellt",
        "correctAnswer": "Antwort",
        "multipleAnswers": "Mehrere Antworten"
      },
      "button": {
        "upload": "Titelbild hochladen",
        "back": "Zurück zur Übersicht",
        "add": "Frage hinzufügen",
        "save": "Quiz speichern",
        "addAnswer": "Antwort hinzufügen"
      },
      "section": {
        "questions": "Fragen und Antworten hinzufügen"
      }
    },
    "link": {
      "title": "Link einfügen",
      "edit": "Link bearbeiten",
      "url": "URL",
      "urlPlaceholder": "https://… oder #p=12",
      "or": "oder",
      "text": "Linktext",
      "newWindow": "In neuem Fenster öffnen",
      "chooseOnMap": "Auf der Map auswählen",
      "apply": "Übernehmen",
      "remove": "Link entfernen",
      "cancel": "Abbrechen",
      "pickerTitle": "Ziel auf der Map auswählen",
      "pickerHint": "Bewegen Sie die Map, um einen Bereich zu wählen, oder öffnen Sie einen Knoten, um direkt darauf zu verlinken.",
      "pickerNodeHint": "Schließen Sie den geöffneten Knoten, um stattdessen auf einen Bereich zu verlinken.",
      "pickerNode": "Knoten {id}",
      "pickerArea": "Bereich auf Ebene {layer}",
      "pickerEmpty": "Noch nichts ausgewählt",
      "pickerUse": "Diesen Link verwenden",
      "pickerBlocked": "Die Map kann hier nicht angezeigt werden. Wählen Sie stattdessen einen Knoten aus der Liste.",
      "pickerNodeFallback": "Knoten"
    },
    "external": {
      "title": "Externe Inhalte verbinden von",
      "connectTitle": "Verbindung zu:",
      "tooltip": "Externe Inhalte",
      "search": "Suchen",
      "searchPlaceholder": "Diese Quelle durchsuchen …",
      "shown": "{shown} von {total} werden angezeigt",
      "noResults": "Nichts gefunden.",
      "loadMore": "Mehr anzeigen",
      "shownUnknownTotal": "{shown} werden angezeigt",
      "retry": "Erneut versuchen",
      "emptyIn": "0 Einträge in {source} gefunden.",
      "error": {
        "network": "Der Server ist nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.",
        "notFound": "{source} ist für dieses Konto nicht verbunden.",
        "rateLimited": "{source} begrenzt die Anfragen. Warte einen Moment und versuche es erneut.",
        "generic": "{source} konnte nicht geladen werden (HTTP {status}). {detail}",
        "session": "Deine Sitzung ist abgelaufen. Melde dich erneut an, um fortzufahren.",
        "notEntitled": "{source} ist für dieses Konto nicht aktiviert. Die Quelle muss zuerst freigeschaltet werden.",
        "forbidden": "Du hast keinen Zugriff auf die externen Quellen dieses Kontos.",
        "configuration": "{source} ist noch nicht konfiguriert. Hinterlege die Zugangsdaten unter Kontoeinstellungen, Manage API.",
        "configurationField": "{source} ist nicht korrekt konfiguriert: prüfe „{field}“ unter Kontoeinstellungen, Manage API.",
        "connectionGone": "Diese Verbindung zu {source} existiert nicht mehr. Wähle eine andere.",
        "upstream": "{source} ist ausgefallen oder hat die gespeicherten Zugangsdaten abgelehnt. Prüfe die Verbindung unter Kontoeinstellungen, Manage API."
      },
      "signIn": "Erneut anmelden",
      "connection": "Verbindung",
      "frameSource": "Quelle: {source}",
      "type": {
        "livedoc": "Live Doc"
      },
      "message": {
        "livedocBlocked": "Ein Confluence Live Doc kann nicht eingebettet werden. Wähle eine klassische Seite oder wandle sie in Confluence um."
      },
      "view": {
        "tiles": "Kacheln",
        "list": "Liste",
        "folders": "Ordner"
      }
    }
  },
  "tour": {
    "steps": {
      "welcome": {
        "title": "Willkommen im Map Builder!",
        "description": "Diese Tour erklärt die Basisfunktionen, um wunderschön gestaltete, hinreißende Wissenslandkarten zu erstellen."
      },
      "newProject": {
        "title": "Ein neues Projekt starten",
        "description": "Mit einer leeren Arbeitsfläche starten oder eine Vorlage verwenden"
      },
      "structure": {
        "title": "Aufbau der Struktur",
        "description": "Hinzufügen von Knotenpunkten und Verbindungen"
      },
      "design": {
        "title": "Design anpassen",
        "description": "Designvorlagen verwenden oder individuelles Design verwenden"
      },
      "content": {
        "title": "Inhalte hinzufügen",
        "description": "Texte, Fotos, Videos, Grafiken - ausführliche Informationen zu jedem Aspekt."
      },
      "layers": {
        "title": "Schaffe ein tiefgehendes Erlebnis",
        "description": "Hinzufügen von Ebenen und Einstellen der Sichtbarkeit von Knotenpunkten bezüglich Ebenen"
      },
      "publish": {
        "title": "Veröffentlichen und teilen der Wissenslandkarte",
        "description": "Zugangsberechtigungen einstellen und die Wissenslandkarte über viele Wege freigeben."
      }
    },
    "stepsStudent": {
      "welcome": {
        "title": "Willkommen und schön, dass du da bist!",
        "description": "Diese Tour zeigt dir kurz und knackig, wie einfach du wunderschöne Wissenslandkarten erstellen kannst."
      },
      "newProject": {
        "title": "Starte ein neues Projekt",
        "description": "Starte dein eigenes Map-Projekt oder verwende die Vorlage deines Lehrers."
      },
      "points": {
        "title": "Zeichne Punkte",
        "description": "Erstelle neue Punkte und gib ihnen ein Design."
      },
      "connections": {
        "title": "Zeige wie alles zusammenhängt",
        "description": "Zeichne Verbindungen zwischen den Punkten."
      },
      "explanations": {
        "title": "Erkläre jeden Punkt",
        "description": "Texte, Fotos, Videos - füge Inhalte hinzu, die die den Punkt erklären."
      },
      "map": {
        "title": "Erstelle eine Map zum Eintauchen!",
        "description": "Füge Ebenen hinzu und stelle die Sichtbarkeit der Punkte ein."
      },
      "simultaneous": {
        "title": "Arbeite mit deiner Gruppe zusammen",
        "description": "Bearbeite deine Wissenslandkarte gemeinsam mit deinen Mitschülern."
      },
      "publish": {
        "title": "Veröffentliche deine Wissenslandkarte",
        "description": "Stelle die Map für die Präsentation live."
      }
    },
    "control": {
      "skip": "Überspringen",
      "back": "Zurück",
      "next": "Nächste",
      "start": "Los geht’s!"
    }
  },
  "tinymce": {
    "expandableList": "Aufklappliste",
    "expandableTitle": "Aufklapptitel",
    "expandableContent": "Aufklappinhalt"
  },
  "multiSelection": {
    "selected": "ausgewählt",
    "delete": "Löschen",
    "deselect": "Alle abwählen"
  },
  "kaia": {
    "trigger": {
      "label": "Mit KAIA chatten",
      "blockedBy": "{name} nutzt KAIA gerade",
      "blocked": "KAIA wird gerade von jemand anderem genutzt"
    },
    "header": {
      "phaseLabel": "Phase {index}/{total} — {name}",
      "verified": "verifiziert",
      "inProgress": "in Arbeit",
      "close": "Schließen",
      "settings": "Map-Einstellungen: KAIA für diese Map ein- oder ausschalten"
    },
    "phases": {
      "onboarding": "Onboarding",
      "sensemaking": "Sensemaking",
      "categoryFormation": "Kategorienbildung",
      "structureChoice": "Strukturwahl",
      "relevanceConstruction": "Relevanzaufbau",
      "layering": "Ebenen",
      "designContent": "Gestaltung und Inhalt",
      "wayfinding": "Orientierung"
    },
    "overview": {
      "title": "KAIA – Kontext KI-Assistent",
      "description": "KAIA führt dich in 7 Phasen durch unseren bewährten Prozess, um eine umfassende und verständliche KontextMap zu erstellen.",
      "verified": "Erfolgreich abgeschlossen und verifiziert",
      "inProgress": "In Arbeit",
      "pending": "Ausstehend",
      "phaseName": "Phase {index} {name}",
      "jump": "Zu dieser Phase springen"
    },
    "validation": {
      "title": "VALIDIERUNG VON PHASE {phase}",
      "confirm": "Bestätigen",
      "edit": "Bearbeiten"
    },
    "review": {
      "refine": "Meine Antworten verbessern"
    },
    "input": {
      "answer": "Schreib deine Antwort …",
      "question": "Schreib deine Frage …",
      "uploadUrl": "Füge einen Link ein oder hänge eine Datei an"
    },
    "mock": {
      "onboarding": {
        "greeting": "Hallo! Ich bin KAIA, dein KI-Assistent für deine KontextMap. Ich führe dich Schritt für Schritt durch den Prozess – wir bauen deine Map direkt hier im Map Builder. Jede Entscheidung wird sofort auf dem Canvas sichtbar. Möchtest du meine Hilfe, oder lieber selbst starten?",
        "greetingQuestion": "Möchtest du meine Hilfe, oder lieber selbst starten?",
        "optHelp": "Ich möchte deine Hilfe",
        "optOwn": "Ich arbeite lieber selbst",
        "standBack": "Alles klar, ich halte mich zurück. Du kannst mich jederzeit dazuholen."
      },
      "phase1": {
        "topic": "Welches Thema soll deine KontextMap behandeln? Beschreibe es in ein bis drei Sätzen.",
        "topicQ": "Welches Thema soll deine KontextMap behandeln?",
        "purpose": {
          "km": "Wissensmanagement & Dokumentation",
          "science": "Wissenschaft & Forschung",
          "comm": "Kommunikation & Orientierung",
          "strategy": "Strategie & Wandel",
          "education": "Bildung & Training",
          "other": "Ich habe einen anderen Zweck"
        },
        "start": {
          "expertise": "Wir haben das Wissen im Team und wollen es strukturieren",
          "content": "Wir haben Inhalte (Studie, Bericht), die visuell dargestellt werden sollen",
          "regulation": "Wir müssen ein Regelwerk für unsere Zielgruppe erklären",
          "research": "Das Thema muss erst recherchiert werden"
        },
        "uploadOffer": "Lade dein Dokument hoch und ich analysiere es.",
        "analyzing": "Ich analysiere die Datei …",
        "analyzed": "Fertig.",
        "goal": "Was sollen die Nutzer deiner Map verstehen oder tun können, nachdem sie sie genutzt haben?",
        "goalQ": "Was sollen die Nutzer deiner Map verstehen oder tun können, nachdem sie sie genutzt haben?",
        "goalExamples": "z. B. 'Alle relevanten Aspekte von 5G für politische Entscheidungen kennen', 'Die neue EU-Verordnung navigieren', 'Fundierte Entscheidungen treffen'",
        "audience": "Für wen ist die Map gedacht?",
        "audienceQ": "Für wen ist die Map gedacht?"
      },
      "validation": {
        "topic": "Thema:",
        "topicVal": "Digitalisierung im Agrarsektor",
        "purpose": "Zweck:",
        "purposeVal": "Kommunikation & Orientierung",
        "start": "Ausgangslage:",
        "startVal": "Vorhandene Inhalte, die visuell dargestellt werden sollen",
        "goal": "Kommunikationsziel:",
        "goalVal": "Überblick über alle relevanten Aspekte, um bessere Entscheidungen zu treffen"
      },
      "phase2": {
        "cat": {
          "a": "Grundlagen",
          "b": "Anwendung",
          "c": "Rahmenbedingungen"
        },
        "intro": "Weiter geht's mit den Hauptbereichen. Wie möchtest du die Hauptbereiche festlegen?",
        "introQ": "Wie möchtest du die Hauptbereiche festlegen?",
        "method": {
          "self": "Ich benenne die Bereiche selbst",
          "suggest": "Mach mir Vorschläge, die ich anpassen kann",
          "fromDoc": "Erstelle die Bereiche aus meinem Dokument"
        },
        "outro": "Super – die Hauptbereiche sind jetzt als Punkte auf dem Canvas sichtbar. (Mock-Ende des Demo-Flows.)"
      }
    },
    "steps": {
      "2_3": {
        "prompt": "Ich schlage dir ein paar Hauptbereiche zu deinem Thema vor."
      },
      "2_3_confirm": {
        "prompt": "Behalte, benenne um oder entferne Bereiche – dann weiter."
      },
      "2_1_manual": {
        "prompt": "Benenne deine Hauptbereiche selbst – tippe einen Namen und schicke ihn ab. Tippe auf „Ich bin fertig“, wenn du fertig bist."
      },
      "2_1_material": {
        "prompt": "Teile ein Dokument oder einen Link und ich schlage dir die Hauptbereiche daraus vor. Häng an, was du hast, und wähle dann „Weiter“."
      },
      "2_5": {
        "prompt": "Hier sind deine Hauptbereiche. Passt das so?",
        "value": "Auf der Canvas angelegt"
      },
      "3_1": {
        "prompt": "Welcher Strukturtyp passt zu deinem Thema?"
      },
      "3_1_order": {
        "prompt": "Deine Bereiche reihen sich nacheinander auf, sobald wir sie anlegen."
      },
      "3_1_help": {
        "prompt": "Mindmap verzweigt aus der Mitte; Prozess ist eine Reihenfolge; Kontextkarte zeigt Querverbindungen; Inseln sind eigenständige Blöcke. Was passt am besten?"
      },
      "3_2": {
        "prompt": "Damit bauen wir deine Map mit dieser Struktur auf. Bereit, deine Hauptbereiche anzulegen?"
      },
      "4_0": {
        "prompt": "Welchen Bereich möchtest du zuerst ausarbeiten?",
        "promptNext": "Welcher Bereich kommt als Nächstes? Wähl einen, oder schließe mit „Ich bin fertig“ ab."
      },
      "4_1": {
        "prompt": "Wie möchtest du die Unterpunkte für {category} entwickeln?"
      },
      "4_1_manual": {
        "prompt": "Benenne die Unterpunkte für {category} selbst – tippe einen Namen und schicke ihn ab. Tippe auf „Ich bin fertig“, wenn du fertig bist."
      },
      "4_1_material": {
        "prompt": "Teil ein Dokument oder einen Link, und ich schlage dir Unterpunkte daraus vor. Häng an, was du hast, und tippe dann auf „Weiter“."
      },
      "4_2b": {
        "prompt": "Ich schlage dir ein paar Unterpunkte für {category} vor."
      },
      "4_2b_confirm": {
        "prompt": "Behalte, benenne um oder entferne Unterpunkte – dann weiter."
      },
      "4_8": {
        "prompt": "Hier ist deine vollständige Struktur auf der Canvas. Funktioniert das?",
        "value": "Auf der Canvas aufgebaut"
      },
      "5_1": {
        "prompt": "Wie viele Ebenen soll deine Map haben?"
      },
      "5_1_accept": {
        "prompt": "Ich richte eine sinnvolle Anzahl Ebenen für deine Struktur ein."
      },
      "5_1_override": {
        "prompt": "Wie viele Ebenen möchtest du? Gib eine Zahl ein."
      },
      "5_3": {
        "prompt": "Ich ordne deine Punkte den Ebenen zu …"
      },
      "5_4": {
        "prompt": "Deine Ebenenstruktur steht. Passt das so?",
        "value": "Auf der Canvas gesetzt"
      },
      "1_0": {
        "prompt": "Deine Map hat schon Inhalte. Soll ich sie mir ansehen und die Grundlagen vorschlagen, oder möchtest du die Fragen lieber selbst beantworten?"
      },
      "1_1": {
        "prompt": "Fangen wir mit dem Kern deiner Map an.",
        "emphasis": "Welches Thema soll deine KontextMap behandeln?"
      },
      "1_2": {
        "prompt": "In welchem Bereich wird deine Map eingesetzt?"
      },
      "1_2_other": {
        "prompt": "Welchen Zweck hast du?"
      },
      "1_2_detail": {
        "prompt": "Du hast „{purpose}“ gewählt. Kannst du etwas genauer beschreiben, was du damit erreichen möchtest?"
      },
      "1_3": {
        "prompt": "Wie ist deine Ausgangslage?"
      },
      "1_3_other": {
        "prompt": "Beschreibe kurz deine Ausgangslage."
      },
      "1_4": {
        "prompt": "Was sollen Nutzer nach der Map verstehen oder können?",
        "examples": "z. B. 'Alle relevanten Aspekte von 5G für politische Entscheidungen kennen', 'Die neue EU-Verordnung navigieren', 'Fundierte Entscheidungen treffen'"
      },
      "1_5": {
        "prompt": "Für wen ist die Map gedacht?"
      },
      "1_6": {
        "prompt": "Ich prüfe kurz den Umfang deines Themas …"
      },
      "1_7": {
        "prompt": "Hier ist die Zusammenfassung deiner Grundlage. Passt das so?"
      },
      "2_1": {
        "prompt": "Jetzt definieren wir deine Hauptbereiche. Wie möchtest du vorgehen?"
      },
      "6_0": {
        "prompt": "Als Nächstes kommen Design und Inhalt. Womit möchtest du starten?"
      },
      "6_0_help": {
        "prompt": "Ich empfehle erst Design, dann Inhalt – so siehst du das Aussehen beim Schreiben. Die Navigation machen wir ganz zum Schluss."
      },
      "6A": {
        "prompt": "Design-Unterstützung kommt bald – ich markiere den Design-Schritt vorerst als erledigt."
      },
      "6B": {
        "prompt": "Verbinde jetzt deine eigene KI im Map Builder, um die Inhalte je Punkt zu schreiben – ich liefere den vollen Kontext (Thema, Zielgruppe, Ziel, Struktur, Map-Memory). Ich markiere den Inhalt als erledigt."
      },
      "6C": {
        "prompt": "Design und Inhalt stehen. Bereit, die Navigation abzuschließen?",
        "value": "Als erledigt markiert"
      },
      "7_1": {
        "prompt": "Richten wir die Navigation ein. Wie sollen die Einstiegspunkte aufgebaut sein?"
      },
      "7_1_stub": {
        "prompt": "Automatische Navigationspunkte kommen bald – vorerst kannst du sie selbst im Map Builder hinzufügen."
      },
      "7_5": {
        "prompt": "Deine Navigation steht. Passt das so?",
        "value": "Auf Ebene 1 gesetzt"
      },
      "4_4_offer": {
        "prompt": "Möchtest du noch ein paar Ideen für {category}?"
      },
      "4_4": {
        "prompt": "Noch ein paar Unterpunkte, die du zu {category} ergänzen könntest:"
      },
      "4_4_confirm": {
        "prompt": "Behalte, was passt – dann weiter."
      },
      "4_5": {
        "prompt": "Welche dieser Punkte in {category} sollen als eigener Knoten auf der Map bleiben?"
      },
      "4_5_confirm": {
        "prompt": "Durchgesehen – weiter."
      },
      "4_5_done": {
        "prompt": "„{category}“ ist fertig."
      },
      "resume": {
        "prompt": "Möchtest du dort weitermachen, wo du aufgehört hast, oder zu einer bestimmten Phase springen?"
      },
      "resume_jump": {
        "prompt": "Zu welcher Phase möchtest du springen?"
      },
      "4_3": {
        "prompt": "Einige Punkte könnten weitere Aspekte haben. Jetzt vertiefen oder weiter?"
      },
      "4_3_pick": {
        "prompt": "Welchen Punkt in {category} möchtest du um Unteraspekte ergänzen?"
      },
      "4_3_suggest": {
        "prompt": "Hier sind einige Unteraspekte für {point}."
      },
      "4_3_confirm": {
        "prompt": "Behalte, was passt – dann weiter."
      },
      "4_7": {
        "prompt": "Ich schlage dir Querverbindungen zwischen verwandten Punkten vor, die noch nicht verbunden sind."
      },
      "4_7_confirm": {
        "prompt": "Behalte die passenden Verbindungen – dann weiter."
      },
      "refine_offer": {
        "prompt": "Möchtest du zuerst eine deiner bisherigen Antworten schärfen? Das hilft mir, dir besseres Feedback und bessere Vorschläge zu geben."
      },
      "refine_form": {
        "prompt": "Hier sind deine Antworten – bearbeite sie nach Belieben und prüfe dann erneut oder mach weiter."
      },
      "completed": {
        "prompt": "Deine Map ist fertig. Möchtest du eine Phase überarbeiten, die Struktur ändern oder schließen?"
      },
      "completed_jump": {
        "prompt": "Welche Phase möchtest du überarbeiten?"
      },
      "completed_change_structure": {
        "prompt": "Zu welcher Struktur soll ich wechseln? Deine Bereiche und Punkte bleiben – nur ihre Anordnung ändert sich."
      },
      "7_1_nav": {
        "prompt": "Ich lege für jeden Bereich einen Navigationspunkt an, damit deine Leser direkt dorthin zoomen können."
      },
      "sensemaking_review": {
        "analyzing": "Ich schaue mir deine Map an und stelle die Grundlage zusammen …"
      }
    },
    "fields": {
      "categories": "Hauptbereiche",
      "structure_type": "Strukturtyp",
      "structure": "Struktur",
      "layers": "Ebenen",
      "topic": "Thema",
      "purpose": "Zweck",
      "purpose_detail": "Zweck-Details",
      "starting_situation": "Ausgangslage",
      "communication_goal": "Kommunikationsziel",
      "audience": "Zielgruppe",
      "prior_knowledge": "Vorwissen",
      "design_content": "Design & Inhalt",
      "navigation": "Navigation",
      "anchor": "Ankerpunkt"
    },
    "options": {
      "flow": {
        "continue": "Weiter",
        "done": "Ich bin fertig",
        "add_own": "Ich ergänze eigene"
      },
      "supplements": {
        "more": "Ja, noch ein paar Ideen",
        "skip": "Nein, weiter"
      },
      "onboarding": {
        "help": "Ich möchte deine Hilfe",
        "own": "Ich möchte allein arbeiten"
      },
      "sensemaking": {
        "purpose": {
          "knowledge_management": "Wissensmanagement & Dokumentation",
          "science_research": "Wissenschaft & Forschung",
          "communication_orientation": "Kommunikation & Orientierung",
          "strategy_change": "Strategie & Wandel",
          "education_training": "Bildung & Training",
          "public_sector": "Öffentlicher Sektor & Smart Governance",
          "compliance_law": "Compliance & Recht",
          "other": "Ich habe einen anderen Zweck"
        },
        "starting_situation": {
          "have_expertise": "Wir haben die Expertise und wollen sie strukturieren",
          "have_content": "Wir haben Inhalte, die wir visuell aufbereiten wollen",
          "explain_regulations": "Wir müssen Regelwerke für unsere Zielgruppe erklären",
          "needs_research": "Das Thema muss erst recherchiert werden",
          "other": "Ich habe eine andere Ausgangslage"
        }
      },
      "category_formation": {
        "manual": "Ich benenne sie selbst",
        "suggestions": "Mach mir Vorschläge",
        "material": "Aus meinem Dokument"
      },
      "structure_choice": {
        "mindmap": "Mindmap",
        "process": "Prozess",
        "network": "Kontextkarte",
        "islands": "Inseln",
        "help": "Hilf mir bei der Wahl"
      },
      "relevance_construction": {
        "choose_category": "Kategorie wählen"
      },
      "layering": {
        "accept_recommendation": "Empfehlung übernehmen",
        "override": "Selbst festlegen"
      },
      "design_and_content": {
        "design_first": "Erst Design",
        "content_first": "Erst Inhalt",
        "help": "Hilf mir bei der Wahl"
      },
      "wayfinding": {
        "category_links": "Links zu Kategorien",
        "guiding_question_links": "Leitfragen",
        "user_defined_links": "Ich lege sie selbst fest"
      },
      "resume": {
        "continue": "Da weitermachen, wo ich war",
        "jump": "Zu einer Phase springen"
      },
      "deepen": {
        "deepen": "Jetzt vertiefen",
        "skip": "Weiter"
      },
      "refine": {
        "adjust": "Antworten verbessern",
        "continue": "Weiter",
        "recheck": "Noch einmal prüfen",
        "done": "Fertig – weiter",
        "topic": "Thema",
        "purpose": "Zweck",
        "starting_situation": "Ausgangslage",
        "communication_goal": "Kommunikationsziel",
        "audience": "Zielgruppe"
      },
      "completed": {
        "revisit": "Eine Phase überarbeiten",
        "change_structure": "Struktur ändern",
        "close": "KAIA schließen"
      },
      "removeCategory": "Diese Kategorie und alles darunter entfernen",
      "removeCategoryConfirm": "„{name}“ samt allen Unterkategorien und Punkten entfernen? Das lässt sich nicht rückgängig machen.",
      "recalcLayout": "Layout neu berechnen",
      "recalcLayoutTitle": "Dieses Layout erneut anwenden – ordnet die Punkte neu an, ohne sonst etwas zu ändern",
      "anchor": {
        "use_selected": "Ausgewählten Punkt verwenden",
        "cancel": "Abbrechen"
      },
      "sensemaking_entry": {
        "answer": "Ich beantworte die Fragen",
        "analyse": "Meine Map analysieren"
      }
    },
    "prose": {
      "suggestionsUnavailable": "Diesmal konnte ich keine Vorschläge holen.",
      "suggestionsKeepFailing": "Die Vorschläge schlagen gerade wiederholt fehl – machen wir weiter und versuchen es anders.",
      "aiTimeout": "Der KI-Dienst hat zu lange gebraucht – versuch es gleich noch einmal.",
      "reviewUnavailable": "Ich konnte das gerade nicht prüfen – wir machen einfach weiter.",
      "fallbackArea": "diesen Bereich",
      "fallbackPoint": "diesen Punkt",
      "fallbackPurpose": "deinem Zweck",
      "affectedPhases": "Hinweis — diese Änderung kann sich auswirken auf: {phases}. Es wird nichts zurückgesetzt; du kannst es hier anpassen.",
      "manualAdded": "„{name}“ hinzugefügt. Ergänze weitere oder tippe auf „Ich bin fertig“.",
      "manualAddFailed": "Ich konnte den Punkt nicht anlegen. Versuch es noch einmal oder tippe auf „Ich bin fertig“.",
      "greeting": {
        "blank": "Hi! Ich bin KAIA, deine KI-Assistentin für deine KontextMap. Ich führe dich Schritt für Schritt – wir bauen sie direkt hier im Map Builder. Möchtest du meine Hilfe oder lieber allein arbeiten?",
        "template": "Hi! Ich bin KAIA. Du startest mit einer Vorlage – ich helfe dir, sie anzupassen. Möchtest du meine Hilfe oder lieber allein arbeiten?",
        "welcomeBack": "Willkommen zurück! Deine Map ist schon in Arbeit."
      },
      "cannotAnswerYet": "Freie Fragen kann ich noch nicht beantworten – nutze bitte die Optionen oben oder arbeite allein weiter.",
      "steppedBack": "Alles klar, ich halte mich zurück. Du kannst mich jederzeit dazuholen.",
      "intro": "Hi! Ich bin KAIA, deine Assistentin für deine KontextMap. Wir gehen Schritt für Schritt vor – direkt hier im Map Builder.",
      "completed": "Deine KontextMap ist fertig – alle Phasen sind abgeschlossen. Du kannst sie jetzt veröffentlichen.",
      "materialAdded": "„{name}“ hinzugefügt. Ich lese es gerade und baue darauf auf, sobald ich fertig bin.",
      "materialAddFailed": "Das konnte ich nicht anhängen. Versuch ein PDF, Word, PowerPoint oder Bild — oder einen Link.",
      "sensemakingUnavailable": "Ich konnte deine Map nicht automatisch analysieren – lass uns die Grundlage gemeinsam zusammenstellen.",
      "pickAnchor": "Wähle einen Punkt auf der Map aus und dann „Ausgewählten Punkt verwenden“.",
      "anchorSet": "Ankerpunkt auf „{name}“ gesetzt.",
      "noNodeSelected": "Noch kein Punkt ausgewählt – klicke zuerst einen auf der Map an."
    },
    "canvas": {
      "updated": "Die Canvas wurde aktualisiert."
    },
    "thinking": {
      "default": "Lass mich kurz überlegen …",
      "categories": "Ich überlege mir Kategorien …",
      "subpoints": "Ich überlege mir Unterpunkte …",
      "structure": "Ich denke über die Struktur nach …",
      "connections": "Ich suche nach Verbindungen …",
      "layer_count": "Ich plane die Ebenen …",
      "topic_scope": "Ich prüfe den Themenumfang …",
      "category_quality": "Ich prüfe die Kategorien …",
      "balance": "Ich prüfe die Balance …",
      "reachability": "Ich prüfe die Navigation …",
      "sensemaking": "Ich analysiere deine Map …"
    },
    "openQuestion": {
      "submit": "Senden"
    },
    "suggestion": {
      "keep": "Behalten",
      "remove": "Entfernen",
      "rename": "Umbenennen",
      "keepAll": "Alle behalten",
      "removeAll": "Alle entfernen"
    },
    "relevance": {
      "keep": "Behalten",
      "memory": "In Map-Memory",
      "unsure": "Unsicher",
      "remove": "Entfernen",
      "keepAll": "Alle behalten",
      "memoryAll": "Alle in Map-Memory",
      "unsureAll": "Bei allen unsicher"
    },
    "materials": {
      "title": "Dokumente zu dieser Karte",
      "hint": "Meine Vorschläge und die für jeden Punkt generierten Texte stützen sich auf diese Dokumente. Leserinnen und Leser sehen sie nie, und sie werden nie zitiert.",
      "none": "Dieser Karte ist noch kein Dokument angehängt.",
      "untitled": "Angehängtes Dokument",
      "reading": "Das Dokument wird gelesen …",
      "failed": "Dieses Dokument konnte nicht gelesen werden.",
      "fromDeletedPoint": "Von einem gelöschten Punkt"
    }
  },
  "features": {
    "headline": {
      "client": "Kunde {name}",
      "package": "Paket {name}"
    },
    "section": {
      "quotas": "Kontingente",
      "roleQuotas": "Nutzerkontingente pro Rolle",
      "permissions": "Berechtigungen",
      "features": "Funktionen",
      "externalContent": "Externe Inhaltsquellen",
      "payment": "Zahlungseinstellungen",
      "validity": "Gültigkeit",
      "content": "Inhalte"
    },
    "quota": {
      "layer": "Ebenen-Kontingent",
      "map": "Map-Kontingent",
      "storage": "Speicher-Kontingent",
      "liveMap": "Live-Map-Kontingent",
      "template": "Vorlagen-Kontingent",
      "traffic": "Traffic-Kontingent",
      "user": "Nutzer-Kontingent",
      "admin": "Kontingent Admin-Nutzer",
      "editor": "Kontingent Redakteur-Nutzer",
      "guest": "Kontingent Gast-Nutzer",
      "student": "Kontingent Schüler-Nutzer",
      "activeReaders": "Kontingent aktive Leser",
      "editingUser": "Kontingent bearbeitende Nutzer"
    },
    "quotaHint": {
      "layer": "Maximale Anzahl Ebenen pro Map",
      "map": "Maximale Anzahl Maps",
      "storage": "Grenze für gespeicherte Mediendateien in MiB",
      "liveMap": "Maximale Anzahl Maps, die live gehen dürfen",
      "template": "Maximale Anzahl eigener Objektvorlagen",
      "traffic": "Monatliche Grenze übertragener Daten in MiB",
      "user": "Maximale Anzahl Nutzer",
      "admin": "Maximale Anzahl Nutzer mit der Rolle Admin",
      "editor": "Maximale Anzahl Nutzer mit der Rolle Redakteur",
      "guest": "Maximale Anzahl Nutzer mit der Rolle Gast",
      "student": "Maximale Anzahl Nutzer mit der Rolle Schüler",
      "activeReaders": "Monatliche Grenze der Besucher",
      "editingUser": "Maximale Anzahl Nutzer, die Maps bearbeiten dürfen"
    },
    "can": {
      "editMap": "Maps bearbeiten",
      "editPopups": "Popup-Inhalte bearbeiten",
      "embedMap": "Maps auf anderen Seiten einbetten",
      "publicMaps": "Maps veröffentlichen",
      "privateMaps": "Maps als Entwurf halten",
      "selectDesignTemplates": "Objektvorlagen verwenden",
      "saveMapState": "Map-Zustand der Lesenden speichern"
    },
    "has": {
      "analytics": "Analytics in Maps",
      "articles": "Langtext-Artikel",
      "assistant": "KAIA-Assistent zum Map-Aufbau",
      "contentLlm": "KI-Inhaltserstellung",
      "assetManagement": "Verwaltung von Mediendateien",
      "cname": "Eigene Domain (CNAME)",
      "cookieConsent": "Cookie-Einwilligungsdialog",
      "customDesign": "Design-Einstellungen an Punkten und Verbindungslinien",
      "customLoginPage": "Eigene Login-Seite",
      "designTemplates": "Objektvorlagen erstellen",
      "editorial": "Anmerkung der Redaktion",
      "globalDesign": "Globale Design-Regeln",
      "glossary": "Glossar",
      "i18n": "Mehrsprachigkeit",
      "mapHeader": "Map-Kopfbereich",
      "mcpServer": "MCP-Server",
      "mediaTemplates": "Medienvorlagen",
      "meteredMaps": "Maps mit Zugriffszählung",
      "mfa": "Zwei-Faktor-Authentifizierung",
      "premiumTemplates": "Premium-Vorlagen",
      "quizzes": "Quizze",
      "references": "Quellen und Literaturverzeichnis",
      "search": "Volltextsuche",
      "seo": "Zusätzliche SEO-Einstellungen",
      "socialNetworkSharing": "Teilen-Schaltflächen in Popups",
      "studentRole": "Rolle Schüler",
      "subdomain": "Subdomain",
      "templates": "Map-Vorlagen",
      "toc": "Inhaltsverzeichnis",
      "translationService": "Übersetzungsdienst",
      "userAccessControl": "Map-spezifische Zugriffssteuerung"
    },
    "field": {
      "clientName": "Name des Kunden",
      "packageName": "Name des Pakets",
      "paymentProvider": "Zahlungsanbieter",
      "customerId": "Kundennummer",
      "activeSince": "Aktiv seit",
      "activeUntil": "Aktiv bis",
      "testingPeriodUntil": "Testzeitraum bis",
      "testingPeriodDays": "Testzeitraum in Tagen",
      "dateHint": "JJJJ-MM-TT hh:mm:ss",
      "fonts": "Schriftarten",
      "mediaCategories": "Medienkategorien",
      "templateThemes": "Vorlagen-Themen",
      "traffic": "Enthaltener Traffic in MiB",
      "slug": "Slug",
      "slugHint": "Aus dem Namen abgeleitete Kennung. Der Zahlungsanbieter ordnet seine Produkte darüber zu."
    },
    "save": "Speichern",
    "savedMessage": "Einstellungen erfolgreich geändert!",
    "loadError": "Beim Laden der Einstellungen ist ein Fehler aufgetreten!",
    "saveError": "Beim Speichern der Einstellungen ist ein Fehler aufgetreten!",
    "categoriesError": "Beim Laden der Medienkategorien ist ein Fehler aufgetreten",
    "payment": {
      "noProvider": "Keiner",
      "notLinked": "Dieses Paket ist noch mit keinem Produkt verbunden, seine Checkout-Links funktionieren daher nicht.",
      "chooseProduct": "Vorhandenes Produkt",
      "chooseOtherProduct": "Zu anderem Produkt wechseln",
      "newProduct": "Oder neues Produkt anlegen",
      "link": "Verbinden",
      "move": "Wechseln",
      "create": "Anlegen und verbinden",
      "unlink": "Trennen",
      "working": "Verbindung zum Zahlungsanbieter…",
      "openAtProvider": "Bei {provider} bearbeiten",
      "productTaken": "{name} (gehört zu {slug})",
      "extensions": "Zusatzoptionen zu diesem Paket. Werden beim Zahlungsanbieter gepflegt.",
      "missingPrices": "Noch kein Preis für: {intervals}. Dieser Abrechnungszeitraum ist erst buchbar, wenn beim Zahlungsanbieter ein Preis hinterlegt ist.",
      "stateMissing": "Das verbundene Produkt existiert beim Zahlungsanbieter nicht mehr. Bitte ein anderes verbinden.",
      "stateMismatched": "Dieses Produkt gehört zu einem anderen Paket oder wurde beim Zahlungsanbieter von Hand verbunden. Hier verbinden, um es zu übernehmen.",
      "loadError": "Der Zahlungsanbieter war nicht erreichbar.",
      "linkError": "Das Produkt konnte nicht verbunden werden.",
      "createError": "Das Produkt konnte nicht angelegt werden.",
      "unlinkError": "Die Verbindung konnte nicht getrennt werden.",
      "detected": "{provider} verkauft dieses Paket bereits als „{name}“. Hier hinterlegen, damit das Paket künftig aus dem Dashboard umbenannt, auf ein anderes Produkt umgestellt oder getrennt werden kann.",
      "adopt": "Dieses Produkt übernehmen",
      "adoptHint": "Beim Zahlungsanbieter ändert sich nichts, der Checkout funktioniert unverändert weiter."
    }
  },
  "packages": {
    "headerTitle": "Pakete",
    "addPackage": "Neues Paket anlegen",
    "createPackage": "Paket anlegen",
    "cancel": "Abbrechen",
    "packageName": "Wie heißt das Paket?",
    "cloneName": "Name der Kopie",
    "inactive": "Inaktiv",
    "edit": "Paket bearbeiten",
    "clone": "Paket klonen",
    "deletePackage": "Endgültig löschen",
    "copyLinkYear": "Kauflink jährlich kopieren",
    "copyLinkMonth": "Kauflink monatlich kopieren",
    "linkCopied": "Kauflink in die Zwischenablage kopiert",
    "linkCopyFailed": "Der Kauflink konnte nicht kopiert werden",
    "maps": "Anzahl Maps:",
    "users": "Anzahl Nutzer:",
    "trial": "Testzeitraum:",
    "trialDays": "{count} Tage",
    "noTrial": "Keiner",
    "unlimited": "Unbegrenzt",
    "createError": "Das Paket konnte nicht angelegt werden",
    "cloneError": "Das Paket konnte nicht geklont werden",
    "deleteError": "Das Paket konnte nicht gelöscht werden",
    "searchPlaceholder": "Pakete durchsuchen...",
    "copySuffix": "{name} (Kopie)",
    "cloneTitle": "Paket klonen",
    "cloneConfirm": "Klonen",
    "payment": {
      "linked": "Wird verkauft",
      "linkedHint": "Dieses Paket ist mit einem Produkt beim Zahlungsanbieter verbunden und kann gekauft werden.",
      "missingPrices": "Preis fehlt",
      "detected": "Verbindung nicht hinterlegt",
      "detectedHint": "Der Zahlungsanbieter verkauft dieses Paket bereits, die Verbindung ist hier aber noch nicht hinterlegt. Zum Hinterlegen das Paket öffnen.",
      "missing": "Produkt weg",
      "mismatched": "Falsches Produkt",
      "unlinked": "Nicht verbunden"
    }
  },
  "fonts": {
    "headerTitle": "Schriften",
    "searchPlaceholder": "Schriften durchsuchen ...",
    "loadError": "Die Schriften konnten nicht geladen werden",
    "empty": "Noch keine Schriften",
    "emptySearch": "Keine Schrift passt zu dieser Suche",
    "table": {
      "id": "ID",
      "family": "Familie",
      "from": "Quelle",
      "created": "Hinzugefügt",
      "actions": "Aktionen",
      "updated": "Geändert"
    },
    "from": {
      "google": "Google Fonts",
      "library": "Schriftbibliothek",
      "external": "Extern",
      "unknown": "Unbekannt"
    },
    "fromDerived": "Nicht erfasst; aus der Stylesheet-Adresse abgeleitet",
    "servedFrom": "Ausgeliefert von {host}",
    "editFont": "Schrift bearbeiten",
    "removeFont": "Schrift löschen",
    "import": {
      "open": "Schrift importieren",
      "title": "Schrift importieren",
      "description": "Wählen Sie, woher die Schrift kommt. Die Optionen tun Folgendes:",
      "sourceLabel": "Importieren von",
      "sourceHints": {
        "google": "Lädt die Familie von Google Fonts herunter und speichert sie hier. Maps liefern die Schrift danach selbst aus, sodass kein Browser eines Besuchers sie bei Google abruft.",
        "library": "Nimmt eine Familie auf, die hier bereits liegt. Es wird nichts heruntergeladen; die Schrift wird nur im Map Builder auswählbar.",
        "external": "Verknüpft ein Stylesheet unter einer Adresse, die Sie eingeben. Die Schriftdateien bleiben auf diesem Host und werden von dort geladen."
      },
      "external": "Externes Stylesheet",
      "externalDescription": "Nur für einen eigenen Host verwenden: Besucher laden die Schrift direkt von dort.",
      "url": "Adresse des Stylesheets",
      "searchPlaceholder": "Familie suchen ...",
      "variants": "{count} Schnitte",
      "noVariants": "Keine Schnitte",
      "alreadyImported": "Bereits importiert",
      "empty": "Keine Familien gefunden",
      "familiesError": "Die Familien konnten nicht geladen werden",
      "chosenFamily": "Familie",
      "displayName": "Anzeigename",
      "displayNameHint": "Standardmäßig der Familienname",
      "fallback": "Ersatzschrift",
      "fallbackHint": "Was der Browser zeigt, während die Schrift lädt",
      "submit": "Importieren",
      "cancel": "Abbrechen",
      "error": "Die Schrift konnte nicht importiert werden",
      "conflict": "Für diese Familie gibt es bereits eine Schrift",
      "success": "{name} wurde importiert"
    },
    "edit": {
      "title": "Schrift bearbeiten",
      "name": "Anzeigename",
      "family": "Schriftliste",
      "familyHint": "Wie in CSS verwendet, endend mit einer generischen Familie",
      "source": "Stylesheet",
      "refresh": "Aus der Quelle aktualisieren",
      "refreshHint": "Liest das Stylesheet erneut und ersetzt die Schnitte der Schrift",
      "refreshUnavailable": "Woher diese Schrift stammt, wurde nie erfasst; sie kann deshalb nicht automatisch neu gelesen werden",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "error": "Die Schrift konnte nicht gespeichert werden",
      "refreshError": "Die Schrift konnte nicht aus ihrer Quelle aktualisiert werden",
      "refreshed": "{name} wurde aus der Quelle aktualisiert"
    },
    "remove": {
      "title": "Schrift löschen",
      "question": "Soll die Schrift „{name}“ wirklich gelöscht werden?",
      "clients": "Sie ist für {count} Kunde(n) verfügbar: {clients}",
      "noClients": "Kein Kunde verwendet diese Schrift.",
      "warning": "Sie wird diesen Kunden entzogen, und jede Map-Komponente, die sie verwendet, fällt auf die Vorgabe des Designs zurück.",
      "confirm": "Endgültig löschen",
      "cancel": "Abbrechen",
      "error": "Die Schrift konnte nicht gelöscht werden",
      "success": "{name} wurde gelöscht"
    }
  }
}
